import YCalendarDOM from '../../../assets/js/YCalendar/YDomEvent';
/*
Copyright (c) 2009, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.net/yui/license.txt
version: 2.7.0
*/
(function () {
    YAHOO.util.Config = function (D) {
        if (D) {
            this.init(D);
        }
    };
    var B = YAHOO.lang, C = YAHOO.util.CustomEvent, A = YAHOO.util.Config;
    A.CONFIG_CHANGED_EVENT = "configChanged";
    A.BOOLEAN_TYPE = "boolean";
    A.prototype = {
        owner: null,
        queueInProgress: false,
        config: null,
        initialConfig: null,
        eventQueue: null,
        configChangedEvent: null,
        init: function (D) {
            this.owner = D;
            this.configChangedEvent = this.createEvent(A.CONFIG_CHANGED_EVENT);
            this.configChangedEvent.signature = C.LIST;
            this.queueInProgress = false;
            this.config = {};
            this.initialConfig = {};
            this.eventQueue = [];
        },
        checkBoolean: function (D) {
            return (typeof D == A.BOOLEAN_TYPE);
        },
        checkNumber: function (D) {
            return (!isNaN(D));
        },
        fireEvent: function (D, F) {
            var E = this.config[D];
            if (E && E.event) {
                E.event.fire(F);
            }
        },
        addProperty: function (E, D) {
            E = E.toLowerCase();
            this.config[E] = D;
            D.event = this.createEvent(E, {scope: this.owner});
            D.event.signature = C.LIST;
            D.key = E;
            if (D.handler) {
                D.event.subscribe(D.handler, this.owner);
            }
            this.setProperty(E, D.value, true);
            if (!D.suppressEvent) {
                this.queueProperty(E, D.value);
            }
        },
        getConfig: function () {
            var D = {}, F = this.config, G, E;
            for (G in F) {
                if (B.hasOwnProperty(F, G)) {
                    E = F[G];
                    if (E && E.event) {
                        D[G] = E.value;
                    }
                }
            }
            return D;
        },
        getProperty: function (D) {
            var E = this.config[D.toLowerCase()];
            if (E && E.event) {
                return E.value;
            } else {
                return undefined;
            }
        },
        resetProperty: function (D) {
            D = D.toLowerCase();
            var E = this.config[D];
            if (E && E.event) {
                if (this.initialConfig[D] && !B.isUndefined(this.initialConfig[D])) {
                    this.setProperty(D, this.initialConfig[D]);
                    return true;
                }
            } else {
                return false;
            }
        },
        setProperty: function (E, G, D) {
            var F;
            E = E.toLowerCase();
            if (this.queueInProgress && !D) {
                this.queueProperty(E, G);
                return true;
            } else {
                F = this.config[E];
                if (F && F.event) {
                    if (F.validator && !F.validator(G)) {
                        return false;
                    } else {
                        F.value = G;
                        if (!D) {
                            this.fireEvent(E, G);
                            this.configChangedEvent.fire([E, G]);
                        }
                        return true;
                    }
                } else {
                    return false;
                }
            }
        },
        queueProperty: function (S, P) {
            S = S.toLowerCase();
            var R = this.config[S], K = false, J, G, H, I, O, Q, F, M, N, D, L, T, E;
            if (R && R.event) {
                if (!B.isUndefined(P) && R.validator && !R.validator(P)) {
                    return false;
                } else {
                    if (!B.isUndefined(P)) {
                        R.value = P;
                    } else {
                        P = R.value;
                    }
                    K = false;
                    J = this.eventQueue.length;
                    for (L = 0; L < J; L++) {
                        G = this.eventQueue[L];
                        if (G) {
                            H = G[0];
                            I = G[1];
                            if (H == S) {
                                this.eventQueue[L] = null;
                                this.eventQueue.push([S, (!B.isUndefined(P) ? P : I)]);
                                K = true;
                                break;
                            }
                        }
                    }
                    if (!K && !B.isUndefined(P)) {
                        this.eventQueue.push([S, P]);
                    }
                }
                if (R.supercedes) {
                    O = R.supercedes.length;
                    for (T = 0; T < O; T++) {
                        Q = R.supercedes[T];
                        F = this.eventQueue.length;
                        for (E = 0; E < F; E++) {
                            M = this.eventQueue[E];
                            if (M) {
                                N = M[0];
                                D = M[1];
                                if (N == Q.toLowerCase()) {
                                    this.eventQueue.push([N, D]);
                                    this.eventQueue[E] = null;
                                    break;
                                }
                            }
                        }
                    }
                }
                return true;
            } else {
                return false;
            }
        },
        refireEvent: function (D) {
            D = D.toLowerCase();
            var E = this.config[D];
            if (E && E.event && !B.isUndefined(E.value)) {
                if (this.queueInProgress) {
                    this.queueProperty(D);
                } else {
                    this.fireEvent(D, E.value);
                }
            }
        },
        applyConfig: function (D, G) {
            var F, E;
            if (G) {
                E = {};
                for (F in D) {
                    if (B.hasOwnProperty(D, F)) {
                        E[F.toLowerCase()] = D[F];
                    }
                }
                this.initialConfig = E;
            }
            for (F in D) {
                if (B.hasOwnProperty(D, F)) {
                    this.queueProperty(F, D[F]);
                }
            }
        },
        refresh: function () {
            var D;
            for (D in this.config) {
                if (B.hasOwnProperty(this.config, D)) {
                    this.refireEvent(D);
                }
            }
        },
        fireQueue: function () {
            var E, H, D, G, F;
            this.queueInProgress = true;
            for (E = 0; E < this.eventQueue.length; E++) {
                H = this.eventQueue[E];
                if (H) {
                    D = H[0];
                    G = H[1];
                    F = this.config[D];
                    F.value = G;
                    this.eventQueue[E] = null;
                    this.fireEvent(D, G);
                }
            }
            this.queueInProgress = false;
            this.eventQueue = [];
        },
        subscribeToConfigEvent: function (E, F, H, D) {
            var G = this.config[E.toLowerCase()];
            if (G && G.event) {
                if (!A.alreadySubscribed(G.event, F, H)) {
                    G.event.subscribe(F, H, D);
                }
                return true;
            } else {
                return false;
            }
        },
        unsubscribeFromConfigEvent: function (D, E, G) {
            var F = this.config[D.toLowerCase()];
            if (F && F.event) {
                return F.event.unsubscribe(E, G);
            } else {
                return false;
            }
        },
        toString: function () {
            var D = "Config";
            if (this.owner) {
                D += " [" + this.owner.toString() + "]";
            }
            return D;
        },
        outputEventQueue: function () {
            var D = "", G, E, F = this.eventQueue.length;
            for (E = 0; E < F; E++) {
                G = this.eventQueue[E];
                if (G) {
                    D += G[0] + "=" + G[1] + ", ";
                }
            }
            return D;
        },
        destroy: function () {
            var E = this.config, D, F;
            for (D in E) {
                if (B.hasOwnProperty(E, D)) {
                    F = E[D];
                    F.event.unsubscribeAll();
                    F.event = null;
                }
            }
            this.configChangedEvent.unsubscribeAll();
            this.configChangedEvent = null;
            this.owner = null;
            this.config = null;
            this.initialConfig = null;
            this.eventQueue = null;
        }
    };
    A.alreadySubscribed = function (E, H, I) {
        var F = E.subscribers.length, D, G;
        if (F > 0) {
            G = F - 1;
            do {
                D = E.subscribers[G];
                if (D && D.obj == I && D.fn == H) {
                    return true;
                }
            } while (G--);
        }
        return false;
    };
    YAHOO.lang.augmentProto(A, YAHOO.util.EventProvider);
}());
YAHOO.widget.DateMath = {
    DAY: "D",
    WEEK: "W",
    YEAR: "Y",
    MONTH: "M",
    ONE_DAY_MS: 1000 * 60 * 60 * 24,
    WEEK_ONE_JAN_DATE: 1,
    add: function (A, D, C) {
        var F = new Date(A.getTime());
        switch (D) {
            case this.MONTH:
                var E = A.getMonth() + C;
                var B = 0;
                if (E < 0) {
                    while (E < 0) {
                        E += 12;
                        B -= 1;
                    }
                } else {
                    if (E > 11) {
                        while (E > 11) {
                            E -= 12;
                            B += 1;
                        }
                    }
                }
                F.setMonth(E);
                F.setFullYear(A.getFullYear() + B);
                break;
            case this.DAY:
                this._addDays(F, C);
                break;
            case this.YEAR:
                F.setFullYear(A.getFullYear() + C);
                break;
            case this.WEEK:
                this._addDays(F, (C * 7));
                break;
        }
        return F;
    },
    _addDays: function (D, C) {
        if (YAHOO.env.ua.webkit && YAHOO.env.ua.webkit < 420) {
            if (C < 0) {
                for (var B = -128; C < B; C -= B) {
                    D.setDate(D.getDate() + B);
                }
            } else {
                for (var A = 96; C > A; C -= A) {
                    D.setDate(D.getDate() + A);
                }
            }
        }
        D.setDate(D.getDate() + C);
    },
    subtract: function (A, C, B) {
        return this.add(A, C, (B * -1));
    },
    before: function (C, B) {
        var A = B.getTime();
        if (C.getTime() < A) {
            return true;
        } else {
            return false;
        }
    },
    after: function (C, B) {
        var A = B.getTime();
        if (C.getTime() > A) {
            return true;
        } else {
            return false;
        }
    },
    between: function (B, A, C) {
        if (this.after(B, A) && this.before(B, C)) {
            return true;
        } else {
            return false;
        }
    },
    getJan1: function (A) {
        return this.getDate(A, 0, 1);
    },
    getDayOffset: function (B, D) {
        var C = this.getJan1(D);
        var A = Math.ceil((B.getTime() - C.getTime()) / this.ONE_DAY_MS);
        return A;
    },
    getWeekNumber: function (E, B, H) {
        B = B || 0;
        H = H || this.WEEK_ONE_JAN_DATE;
        var I = this.clearTime(E), M, N;
        if (I.getDay() === B) {
            M = I;
        } else {
            M = this.getFirstDayOfWeek(I, B);
        }
        var J = M.getFullYear(), C = M.getTime();
        N = new Date(M.getTime() + 6 * this.ONE_DAY_MS);
        var G;
        if (J !== N.getFullYear() && N.getDate() >= H) {
            G = 1;
        } else {
            var F = this.clearTime(this.getDate(J, 0, H)), A = this.getFirstDayOfWeek(F, B);
            var K = Math.round((I.getTime() - A.getTime()) / this.ONE_DAY_MS);
            var L = K % 7;
            var D = (K - L) / 7;
            G = D + 1;
        }
        return G;
    },
    getFirstDayOfWeek: function (D, A) {
        A = A || 0;
        var B = D.getDay(), C = (B - A + 7) % 7;
        return this.subtract(D, this.DAY, C);
    },
    isYearOverlapWeek: function (A) {
        var C = false;
        var B = this.add(A, this.DAY, 6);
        if (B.getFullYear() != A.getFullYear()) {
            C = true;
        }
        return C;
    },
    isMonthOverlapWeek: function (A) {
        var C = false;
        var B = this.add(A, this.DAY, 6);
        if (B.getMonth() != A.getMonth()) {
            C = true;
        }
        return C;
    },
    findMonthStart: function (A) {
        var B = this.getDate(A.getFullYear(), A.getMonth(), 1);
        return B;
    },
    findMonthEnd: function (B) {
        var D = this.findMonthStart(B);
        var C = this.add(D, this.MONTH, 1);
        var A = this.subtract(C, this.DAY, 1);
        return A;
    },
    clearTime: function (A) {
        A.setHours(12, 0, 0, 0);
        return A;
    },
    getDate: function (D, A, C) {
        var B = null;
        if (YAHOO.lang.isUndefined(C)) {
            C = 1;
        }
        if (D >= 100) {
            B = new Date(D, A, C);
        } else {
            B = new Date();
            B.setFullYear(D);
            B.setMonth(A);
            B.setDate(C);
            B.setHours(0, 0, 0, 0);
        }
        return B;
    }
};
(function () {
    var C = YAHOO.util.Dom, A = YAHOO.util.Event, E = YAHOO.lang, D = YAHOO.widget.DateMath;

    function F(I, G, H) {
        this.init.apply(this, arguments);
    }

    F.IMG_ROOT = null;
    F.DATE = "D";
    F.MONTH_DAY = "MD";
    F.WEEKDAY = "WD";
    F.RANGE = "R";
    F.MONTH = "M";
    F.DISPLAY_DAYS = 42;
    F.STOP_RENDER = "S";
    F.SHORT = "short";
    F.LONG = "long";
    F.MEDIUM = "medium";
    F.ONE_CHAR = "1char";
    F._DEFAULT_CONFIG = {
        PAGEDATE: {key: "pagedate", value: null},
        SELECTED: {key: "selected", value: null},
        TITLE: {key: "title", value: ""},
        CLOSE: {key: "close", value: false},
        IFRAME: {key: "iframe", value: (YAHOO.env.ua.ie && YAHOO.env.ua.ie <= 6) ? true : false},
        MINDATE: {key: "mindate", value: null},
        MAXDATE: {key: "maxdate", value: null},
        MULTI_SELECT: {key: "multi_select", value: false},
        START_WEEKDAY: {key: "start_weekday", value: 0},
        SHOW_WEEKDAYS: {key: "show_weekdays", value: true},
        SHOW_WEEK_HEADER: {key: "show_week_header", value: false},
        SHOW_WEEK_FOOTER: {key: "show_week_footer", value: false},
        HIDE_BLANK_WEEKS: {key: "hide_blank_weeks", value: false},
        NAV_ARROW_LEFT: {key: "nav_arrow_left", value: null},
        NAV_ARROW_RIGHT: {key: "nav_arrow_right", value: null},
        MONTHS_SHORT: {
            key: "months_short",
            value: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        },
        MONTHS_LONG: {
            key: "months_long",
            value: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        },
        WEEKDAYS_1CHAR: {key: "weekdays_1char", value: ["S", "M", "T", "W", "T", "F", "S"]},
        WEEKDAYS_SHORT: {key: "weekdays_short", value: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]},
        WEEKDAYS_MEDIUM: {key: "weekdays_medium", value: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]},
        WEEKDAYS_LONG: {
            key: "weekdays_long",
            value: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        },
        LOCALE_MONTHS: {key: "locale_months", value: "long"},
        LOCALE_WEEKDAYS: {key: "locale_weekdays", value: "short"},
        DATE_DELIMITER: {key: "date_delimiter", value: ","},
        DATE_FIELD_DELIMITER: {key: "date_field_delimiter", value: "/"},
        DATE_RANGE_DELIMITER: {key: "date_range_delimiter", value: "-"},
        MY_MONTH_POSITION: {key: "my_month_position", value: 1},
        MY_YEAR_POSITION: {key: "my_year_position", value: 2},
        MD_MONTH_POSITION: {key: "md_month_position", value: 1},
        MD_DAY_POSITION: {key: "md_day_position", value: 2},
        MDY_MONTH_POSITION: {key: "mdy_month_position", value: 1},
        MDY_DAY_POSITION: {key: "mdy_day_position", value: 2},
        MDY_YEAR_POSITION: {key: "mdy_year_position", value: 3},
        MY_LABEL_MONTH_POSITION: {key: "my_label_month_position", value: 1},
        MY_LABEL_YEAR_POSITION: {key: "my_label_year_position", value: 2},
        MY_LABEL_MONTH_SUFFIX: {key: "my_label_month_suffix", value: " "},
        MY_LABEL_YEAR_SUFFIX: {key: "my_label_year_suffix", value: ""},
        NAV: {key: "navigator", value: null},
        STRINGS: {
            key: "strings",
            value: {previousMonth: "Previous Month", nextMonth: "Next Month", close: "Close"},
            supercedes: ["close", "title"]
        }
    };
    var B = F._DEFAULT_CONFIG;
    F._EVENT_TYPES = {
        BEFORE_SELECT: "beforeSelect",
        SELECT: "select",
        BEFORE_DESELECT: "beforeDeselect",
        DESELECT: "deselect",
        CHANGE_PAGE: "changePage",
        BEFORE_RENDER: "beforeRender",
        RENDER: "render",
        BEFORE_DESTROY: "beforeDestroy",
        DESTROY: "destroy",
        RESET: "reset",
        CLEAR: "clear",
        BEFORE_HIDE: "beforeHide",
        HIDE: "hide",
        BEFORE_SHOW: "beforeShow",
        SHOW: "show",
        BEFORE_HIDE_NAV: "beforeHideNav",
        HIDE_NAV: "hideNav",
        BEFORE_SHOW_NAV: "beforeShowNav",
        SHOW_NAV: "showNav",
        BEFORE_RENDER_NAV: "beforeRenderNav",
        RENDER_NAV: "renderNav"
    };
    F._STYLES = {
        CSS_ROW_HEADER: "calrowhead",
        CSS_ROW_FOOTER: "calrowfoot",
        CSS_CELL: "calcell",
        CSS_CELL_SELECTOR: "selector",
        CSS_CELL_SELECTED: "selected",
        CSS_CELL_SELECTABLE: "selectable",
        CSS_CELL_RESTRICTED: "restricted",
        CSS_CELL_TODAY: "today",
        CSS_CELL_OOM: "oom",
        CSS_CELL_OOB: "previous",
        CSS_HEADER: "calheader",
        CSS_HEADER_TEXT: "calhead",
        CSS_BODY: "calbody",
        CSS_WEEKDAY_CELL: "calweekdaycell",
        CSS_WEEKDAY_ROW: "calweekdayrow",
        CSS_FOOTER: "calfoot",
        CSS_CALENDAR: "yui-calendar",
        CSS_SINGLE: "single",
        CSS_CONTAINER: "yui-calcontainer",
        CSS_NAV_LEFT: "calnavleft",
        CSS_NAV_RIGHT: "calnavright",
        CSS_NAV: "calnav",
        CSS_CLOSE: "calclose",
        CSS_CELL_TOP: "calcelltop",
        CSS_CELL_LEFT: "calcellleft",
        CSS_CELL_RIGHT: "calcellright",
        CSS_CELL_BOTTOM: "calcellbottom",
        CSS_CELL_HOVER: "calcellhover",
        CSS_CELL_HIGHLIGHT1: "highlight1",
        CSS_CELL_HIGHLIGHT2: "highlight2",
        CSS_CELL_HIGHLIGHT3: "highlight3",
        CSS_CELL_HIGHLIGHT4: "highlight4"
    };
    F.prototype = {
        Config: null,
        parent: null,
        index: -1,
        cells: null,
        cellDates: null,
        id: null,
        containerId: null,
        oDomContainer: null,
        today: null,
        renderStack: null,
        _renderStack: null,
        oNavigator: null,
        _selectedDates: null,
        domEventMap: null,
        _parseArgs: function (H) {
            var G = {id: null, container: null, config: null};
            if (H && H.length && H.length > 0) {
                switch (H.length) {
                    case 1:
                        G.id = null;
                        G.container = H[0];
                        G.config = null;
                        break;
                    case 2:
                        if (E.isObject(H[1]) && !H[1].tagName && !(H[1] instanceof String)) {
                            G.id = null;
                            G.container = H[0];
                            G.config = H[1];
                        } else {
                            G.id = H[0];
                            G.container = H[1];
                            G.config = null;
                        }
                        break;
                    default:
                        G.id = H[0];
                        G.container = H[1];
                        G.config = H[2];
                        break;
                }
            } else {
            }
            return G;
        },
        init: function (J, H, I) {
            var G = this._parseArgs(arguments);
            J = G.id;
            H = G.container;
            I = G.config;
            this.oDomContainer = C.get(H);
            if (!this.oDomContainer.id) {
                this.oDomContainer.id = C.generateId();
            }
            if (!J) {
                J = this.oDomContainer.id + "_t";
            }
            this.id = J;
            this.containerId = this.oDomContainer.id;
            this.initEvents();
            this.today = new Date();
            D.clearTime(this.today);
            this.cfg = new YAHOO.util.Config(this);
            this.Options = {};
            this.Locale = {};
            this.initStyles();
            C.addClass(this.oDomContainer, this.Style.CSS_CONTAINER);
            C.addClass(this.oDomContainer, this.Style.CSS_SINGLE);
            this.cellDates = [];
            this.cells = [];
            this.renderStack = [];
            this._renderStack = [];
            this.setupConfig();
            if (I) {
                this.cfg.applyConfig(I, true);
            }
            this.cfg.fireQueue();
        },
        configIframe: function (I, H, J) {
            var G = H[0];
            if (!this.parent) {
                if (C.inDocument(this.oDomContainer)) {
                    if (G) {
                        var K = C.getStyle(this.oDomContainer, "position");
                        if (K == "absolute" || K == "relative") {
                            if (!C.inDocument(this.iframe)) {
                                this.iframe = document.createElement("iframe");
                                this.iframe.src = "javascript:false;";
                                C.setStyle(this.iframe, "opacity", "0");
                                if (YAHOO.env.ua.ie && YAHOO.env.ua.ie <= 6) {
                                    C.addClass(this.iframe, "fixedsize");
                                }
                                this.oDomContainer.insertBefore(this.iframe, this.oDomContainer.firstChild);
                            }
                        }
                    } else {
                        if (this.iframe) {
                            if (this.iframe.parentNode) {
                                this.iframe.parentNode.removeChild(this.iframe);
                            }
                            this.iframe = null;
                        }
                    }
                }
            }
        },
        configTitle: function (H, G, I) {
            var K = G[0];
            if (K) {
                this.createTitleBar(K);
            } else {
                var J = this.cfg.getProperty(B.CLOSE.key);
                if (!J) {
                    this.removeTitleBar();
                } else {
                    this.createTitleBar("&#160;");
                }
            }
        },
        configClose: function (H, G, I) {
            var K = G[0], J = this.cfg.getProperty(B.TITLE.key);
            if (K) {
                if (!J) {
                    this.createTitleBar("&#160;");
                }
                this.createCloseButton();
            } else {
                this.removeCloseButton();
                if (!J) {
                    this.removeTitleBar();
                }
            }
        },
        initEvents: function () {
            var G = F._EVENT_TYPES, I = YAHOO.util.CustomEvent, H = this;
            H.beforeSelectEvent = new I(G.BEFORE_SELECT);
            H.selectEvent = new I(G.SELECT);
            H.beforeDeselectEvent = new I(G.BEFORE_DESELECT);
            H.deselectEvent = new I(G.DESELECT);
            H.changePageEvent = new I(G.CHANGE_PAGE);
            H.beforeRenderEvent = new I(G.BEFORE_RENDER);
            H.renderEvent = new I(G.RENDER);
            H.beforeDestroyEvent = new I(G.BEFORE_DESTROY);
            H.destroyEvent = new I(G.DESTROY);
            H.resetEvent = new I(G.RESET);
            H.clearEvent = new I(G.CLEAR);
            H.beforeShowEvent = new I(G.BEFORE_SHOW);
            H.showEvent = new I(G.SHOW);
            H.beforeHideEvent = new I(G.BEFORE_HIDE);
            H.hideEvent = new I(G.HIDE);
            H.beforeShowNavEvent = new I(G.BEFORE_SHOW_NAV);
            H.showNavEvent = new I(G.SHOW_NAV);
            H.beforeHideNavEvent = new I(G.BEFORE_HIDE_NAV);
            H.hideNavEvent = new I(G.HIDE_NAV);
            H.beforeRenderNavEvent = new I(G.BEFORE_RENDER_NAV);
            H.renderNavEvent = new I(G.RENDER_NAV);
            H.beforeSelectEvent.subscribe(H.onBeforeSelect, this, true);
            H.selectEvent.subscribe(H.onSelect, this, true);
            H.beforeDeselectEvent.subscribe(H.onBeforeDeselect, this, true);
            H.deselectEvent.subscribe(H.onDeselect, this, true);
            H.changePageEvent.subscribe(H.onChangePage, this, true);
            H.renderEvent.subscribe(H.onRender, this, true);
            H.resetEvent.subscribe(H.onReset, this, true);
            H.clearEvent.subscribe(H.onClear, this, true);
        },
        doPreviousMonthNav: function (H, G) {
            A.preventDefault(H);
            setTimeout(function () {
                G.previousMonth();
                var I = C.getElementsByClassName(G.Style.CSS_NAV_LEFT, "a", G.oDomContainer);
                if (I && I[0]) {
                    try {
                        I[0].focus();
                    } catch (J) {
                    }
                }
            }, 0);
        },
        doNextMonthNav: function (H, G) {
            A.preventDefault(H);
            setTimeout(function () {
                G.nextMonth();
                var I = C.getElementsByClassName(G.Style.CSS_NAV_RIGHT, "a", G.oDomContainer);
                if (I && I[0]) {
                    try {
                        I[0].focus();
                    } catch (J) {
                    }
                }
            }, 0);
        },
        doSelectCell: function (M, G) {
            var R, O, I, L;
            var N = A.getTarget(M), H = N.tagName.toLowerCase(), K = false;
            while (H != "td" && !C.hasClass(N, G.Style.CSS_CELL_SELECTABLE)) {
                if (!K && H == "a" && C.hasClass(N, G.Style.CSS_CELL_SELECTOR)) {
                    K = true;
                }
                N = N.parentNode;
                H = N.tagName.toLowerCase();
                if (N == this.oDomContainer || H == "html") {
                    return;
                }
            }
            if (K) {
                A.preventDefault(M);
            }
            R = N;
            if (C.hasClass(R, G.Style.CSS_CELL_SELECTABLE)) {
                L = G.getIndexFromId(R.id);
                if (L > -1) {
                    O = G.cellDates[L];
                    if (O) {
                        I = D.getDate(O[0], O[1] - 1, O[2]);
                        var Q;
                        if (G.Options.MULTI_SELECT) {
                            Q = R.getElementsByTagName("a")[0];
                            if (Q) {
                                Q.blur();
                            }
                            var J = G.cellDates[L];
                            var P = G._indexOfSelectedFieldArray(J);
                            if (P > -1) {
                                G.deselectCell(L);
                            } else {
                                G.selectCell(L);
                            }
                        } else {
                            Q = R.getElementsByTagName("a")[0];
                            if (Q) {
                                Q.blur();
                            }
                            G.selectCell(L);
                        }
                    }
                }
            }
        },
        doCellMouseOver: function (I, H) {
            var G;
            if (I) {
                G = A.getTarget(I);
            } else {
                G = this;
            }
            while (G.tagName && G.tagName.toLowerCase() != "td") {
                G = G.parentNode;
                if (!G.tagName || G.tagName.toLowerCase() == "html") {
                    return;
                }
            }
            if (C.hasClass(G, H.Style.CSS_CELL_SELECTABLE)) {
                C.addClass(G, H.Style.CSS_CELL_HOVER);
            }
        },
        doCellMouseOut: function (I, H) {
            var G;
            if (I) {
                G = A.getTarget(I);
            } else {
                G = this;
            }
            while (G.tagName && G.tagName.toLowerCase() != "td") {
                G = G.parentNode;
                if (!G.tagName || G.tagName.toLowerCase() == "html") {
                    return;
                }
            }
            if (C.hasClass(G, H.Style.CSS_CELL_SELECTABLE)) {
                C.removeClass(G, H.Style.CSS_CELL_HOVER);
            }
        },
        setupConfig: function () {
            var G = this.cfg;
            G.addProperty(B.PAGEDATE.key, {value: new Date(), handler: this.configPageDate});
            G.addProperty(B.SELECTED.key, {value: [], handler: this.configSelected});
            G.addProperty(B.TITLE.key, {value: B.TITLE.value, handler: this.configTitle});
            G.addProperty(B.CLOSE.key, {value: B.CLOSE.value, handler: this.configClose});
            G.addProperty(B.IFRAME.key, {value: B.IFRAME.value, handler: this.configIframe, validator: G.checkBoolean});
            G.addProperty(B.MINDATE.key, {value: B.MINDATE.value, handler: this.configMinDate});
            G.addProperty(B.MAXDATE.key, {value: B.MAXDATE.value, handler: this.configMaxDate});
            G.addProperty(B.MULTI_SELECT.key, {
                value: B.MULTI_SELECT.value,
                handler: this.configOptions,
                validator: G.checkBoolean
            });
            G.addProperty(B.START_WEEKDAY.key, {
                value: B.START_WEEKDAY.value,
                handler: this.configOptions,
                validator: G.checkNumber
            });
            G.addProperty(B.SHOW_WEEKDAYS.key, {
                value: B.SHOW_WEEKDAYS.value,
                handler: this.configOptions,
                validator: G.checkBoolean
            });
            G.addProperty(B.SHOW_WEEK_HEADER.key, {
                value: B.SHOW_WEEK_HEADER.value,
                handler: this.configOptions,
                validator: G.checkBoolean
            });
            G.addProperty(B.SHOW_WEEK_FOOTER.key, {
                value: B.SHOW_WEEK_FOOTER.value,
                handler: this.configOptions,
                validator: G.checkBoolean
            });
            G.addProperty(B.HIDE_BLANK_WEEKS.key, {
                value: B.HIDE_BLANK_WEEKS.value,
                handler: this.configOptions,
                validator: G.checkBoolean
            });
            G.addProperty(B.NAV_ARROW_LEFT.key, {value: B.NAV_ARROW_LEFT.value, handler: this.configOptions});
            G.addProperty(B.NAV_ARROW_RIGHT.key, {value: B.NAV_ARROW_RIGHT.value, handler: this.configOptions});
            G.addProperty(B.MONTHS_SHORT.key, {value: B.MONTHS_SHORT.value, handler: this.configLocale});
            G.addProperty(B.MONTHS_LONG.key, {value: B.MONTHS_LONG.value, handler: this.configLocale});
            G.addProperty(B.WEEKDAYS_1CHAR.key, {value: B.WEEKDAYS_1CHAR.value, handler: this.configLocale});
            G.addProperty(B.WEEKDAYS_SHORT.key, {value: B.WEEKDAYS_SHORT.value, handler: this.configLocale});
            G.addProperty(B.WEEKDAYS_MEDIUM.key, {value: B.WEEKDAYS_MEDIUM.value, handler: this.configLocale});
            G.addProperty(B.WEEKDAYS_LONG.key, {value: B.WEEKDAYS_LONG.value, handler: this.configLocale});
            var H = function () {
                G.refireEvent(B.LOCALE_MONTHS.key);
                G.refireEvent(B.LOCALE_WEEKDAYS.key);
            };
            G.subscribeToConfigEvent(B.START_WEEKDAY.key, H, this, true);
            G.subscribeToConfigEvent(B.MONTHS_SHORT.key, H, this, true);
            G.subscribeToConfigEvent(B.MONTHS_LONG.key, H, this, true);
            G.subscribeToConfigEvent(B.WEEKDAYS_1CHAR.key, H, this, true);
            G.subscribeToConfigEvent(B.WEEKDAYS_SHORT.key, H, this, true);
            G.subscribeToConfigEvent(B.WEEKDAYS_MEDIUM.key, H, this, true);
            G.subscribeToConfigEvent(B.WEEKDAYS_LONG.key, H, this, true);
            G.addProperty(B.LOCALE_MONTHS.key, {value: B.LOCALE_MONTHS.value, handler: this.configLocaleValues});
            G.addProperty(B.LOCALE_WEEKDAYS.key, {value: B.LOCALE_WEEKDAYS.value, handler: this.configLocaleValues});
            G.addProperty(B.DATE_DELIMITER.key, {value: B.DATE_DELIMITER.value, handler: this.configLocale});
            G.addProperty(B.DATE_FIELD_DELIMITER.key, {
                value: B.DATE_FIELD_DELIMITER.value,
                handler: this.configLocale
            });
            G.addProperty(B.DATE_RANGE_DELIMITER.key, {
                value: B.DATE_RANGE_DELIMITER.value,
                handler: this.configLocale
            });
            G.addProperty(B.MY_MONTH_POSITION.key, {
                value: B.MY_MONTH_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MY_YEAR_POSITION.key, {
                value: B.MY_YEAR_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MD_MONTH_POSITION.key, {
                value: B.MD_MONTH_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MD_DAY_POSITION.key, {
                value: B.MD_DAY_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MDY_MONTH_POSITION.key, {
                value: B.MDY_MONTH_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MDY_DAY_POSITION.key, {
                value: B.MDY_DAY_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MDY_YEAR_POSITION.key, {
                value: B.MDY_YEAR_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MY_LABEL_MONTH_POSITION.key, {
                value: B.MY_LABEL_MONTH_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MY_LABEL_YEAR_POSITION.key, {
                value: B.MY_LABEL_YEAR_POSITION.value,
                handler: this.configLocale,
                validator: G.checkNumber
            });
            G.addProperty(B.MY_LABEL_MONTH_SUFFIX.key, {
                value: B.MY_LABEL_MONTH_SUFFIX.value,
                handler: this.configLocale
            });
            G.addProperty(B.MY_LABEL_YEAR_SUFFIX.key, {
                value: B.MY_LABEL_YEAR_SUFFIX.value,
                handler: this.configLocale
            });
            G.addProperty(B.NAV.key, {value: B.NAV.value, handler: this.configNavigator});
            G.addProperty(B.STRINGS.key, {
                value: B.STRINGS.value, handler: this.configStrings, validator: function (I) {
                    return E.isObject(I);
                }, supercedes: B.STRINGS.supercedes
            });
        },
        configStrings: function (H, G, I) {
            var J = E.merge(B.STRINGS.value, G[0]);
            this.cfg.setProperty(B.STRINGS.key, J, true);
        },
        configPageDate: function (H, G, I) {
            this.cfg.setProperty(B.PAGEDATE.key, this._parsePageDate(G[0]), true);
        },
        configMinDate: function (H, G, I) {
            var J = G[0];
            if (E.isString(J)) {
                J = this._parseDate(J);
                this.cfg.setProperty(B.MINDATE.key, D.getDate(J[0], (J[1] - 1), J[2]));
            }
        },
        configMaxDate: function (H, G, I) {
            var J = G[0];
            if (E.isString(J)) {
                J = this._parseDate(J);
                this.cfg.setProperty(B.MAXDATE.key, D.getDate(J[0], (J[1] - 1), J[2]));
            }
        },
        configSelected: function (I, G, K) {
            var H = G[0], J = B.SELECTED.key;
            if (H) {
                if (E.isString(H)) {
                    this.cfg.setProperty(J, this._parseDates(H), true);
                }
            }
            if (!this._selectedDates) {
                this._selectedDates = this.cfg.getProperty(J);
            }
        },
        configOptions: function (H, G, I) {
            this.Options[H.toUpperCase()] = G[0];
        },
        configLocale: function (H, G, I) {
            this.Locale[H.toUpperCase()] = G[0];
            this.cfg.refireEvent(B.LOCALE_MONTHS.key);
            this.cfg.refireEvent(B.LOCALE_WEEKDAYS.key);
        },
        configLocaleValues: function (J, I, K) {
            J = J.toLowerCase();
            var M = I[0], H = this.cfg, N = this.Locale;
            switch (J) {
                case B.LOCALE_MONTHS.key:
                    switch (M) {
                        case F.SHORT:
                            N.LOCALE_MONTHS = H.getProperty(B.MONTHS_SHORT.key).concat();
                            break;
                        case F.LONG:
                            N.LOCALE_MONTHS = H.getProperty(B.MONTHS_LONG.key).concat();
                            break;
                    }
                    break;
                case B.LOCALE_WEEKDAYS.key:
                    switch (M) {
                        case F.ONE_CHAR:
                            N.LOCALE_WEEKDAYS = H.getProperty(B.WEEKDAYS_1CHAR.key).concat();
                            break;
                        case F.SHORT:
                            N.LOCALE_WEEKDAYS = H.getProperty(B.WEEKDAYS_SHORT.key).concat();
                            break;
                        case F.MEDIUM:
                            N.LOCALE_WEEKDAYS = H.getProperty(B.WEEKDAYS_MEDIUM.key).concat();
                            break;
                        case F.LONG:
                            N.LOCALE_WEEKDAYS = H.getProperty(B.WEEKDAYS_LONG.key).concat();
                            break;
                    }
                    var L = H.getProperty(B.START_WEEKDAY.key);
                    if (L > 0) {
                        for (var G = 0; G < L; ++G) {
                            N.LOCALE_WEEKDAYS.push(N.LOCALE_WEEKDAYS.shift());
                        }
                    }
                    break;
            }
        },
        configNavigator: function (H, G, I) {
            var J = G[0];
            if (YAHOO.widget.CalendarNavigator && (J === true || E.isObject(J))) {
                if (!this.oNavigator) {
                    this.oNavigator = new YAHOO.widget.CalendarNavigator(this);
                    this.beforeRenderEvent.subscribe(function () {
                        if (!this.pages) {
                            this.oNavigator.erase();
                        }
                    }, this, true);
                }
            } else {
                if (this.oNavigator) {
                    this.oNavigator.destroy();
                    this.oNavigator = null;
                }
            }
        },
        initStyles: function () {
            var G = F._STYLES;
            this.Style = {
                CSS_ROW_HEADER: G.CSS_ROW_HEADER,
                CSS_ROW_FOOTER: G.CSS_ROW_FOOTER,
                CSS_CELL: G.CSS_CELL,
                CSS_CELL_SELECTOR: G.CSS_CELL_SELECTOR,
                CSS_CELL_SELECTED: G.CSS_CELL_SELECTED,
                CSS_CELL_SELECTABLE: G.CSS_CELL_SELECTABLE,
                CSS_CELL_RESTRICTED: G.CSS_CELL_RESTRICTED,
                CSS_CELL_TODAY: G.CSS_CELL_TODAY,
                CSS_CELL_OOM: G.CSS_CELL_OOM,
                CSS_CELL_OOB: G.CSS_CELL_OOB,
                CSS_HEADER: G.CSS_HEADER,
                CSS_HEADER_TEXT: G.CSS_HEADER_TEXT,
                CSS_BODY: G.CSS_BODY,
                CSS_WEEKDAY_CELL: G.CSS_WEEKDAY_CELL,
                CSS_WEEKDAY_ROW: G.CSS_WEEKDAY_ROW,
                CSS_FOOTER: G.CSS_FOOTER,
                CSS_CALENDAR: G.CSS_CALENDAR,
                CSS_SINGLE: G.CSS_SINGLE,
                CSS_CONTAINER: G.CSS_CONTAINER,
                CSS_NAV_LEFT: G.CSS_NAV_LEFT,
                CSS_NAV_RIGHT: G.CSS_NAV_RIGHT,
                CSS_NAV: G.CSS_NAV,
                CSS_CLOSE: G.CSS_CLOSE,
                CSS_CELL_TOP: G.CSS_CELL_TOP,
                CSS_CELL_LEFT: G.CSS_CELL_LEFT,
                CSS_CELL_RIGHT: G.CSS_CELL_RIGHT,
                CSS_CELL_BOTTOM: G.CSS_CELL_BOTTOM,
                CSS_CELL_HOVER: G.CSS_CELL_HOVER,
                CSS_CELL_HIGHLIGHT1: G.CSS_CELL_HIGHLIGHT1,
                CSS_CELL_HIGHLIGHT2: G.CSS_CELL_HIGHLIGHT2,
                CSS_CELL_HIGHLIGHT3: G.CSS_CELL_HIGHLIGHT3,
                CSS_CELL_HIGHLIGHT4: G.CSS_CELL_HIGHLIGHT4
            };
        },
        buildMonthLabel: function () {
            return this._buildMonthLabel(this.cfg.getProperty(B.PAGEDATE.key));
        },
        _buildMonthLabel: function (G) {
            var I = this.Locale.LOCALE_MONTHS[G.getMonth()] + this.Locale.MY_LABEL_MONTH_SUFFIX,
                H = G.getFullYear() + this.Locale.MY_LABEL_YEAR_SUFFIX;
            if (this.Locale.MY_LABEL_MONTH_POSITION == 2 || this.Locale.MY_LABEL_YEAR_POSITION == 1) {
                return H + I;
            } else {
                return I + H;
            }
        },
        buildDayLabel: function (G) {
            return G.getDate();
        },
        createTitleBar: function (G) {
            var H = C.getElementsByClassName(YAHOO.widget.CalendarGroup.CSS_2UPTITLE, "div", this.oDomContainer)[0] || document.createElement("div");
            H.className = YAHOO.widget.CalendarGroup.CSS_2UPTITLE;
            H.innerHTML = G;
            this.oDomContainer.insertBefore(H, this.oDomContainer.firstChild);
            C.addClass(this.oDomContainer, "withtitle");
            return H;
        },
        removeTitleBar: function () {
            var G = C.getElementsByClassName(YAHOO.widget.CalendarGroup.CSS_2UPTITLE, "div", this.oDomContainer)[0] || null;
            if (G) {
                A.purgeElement(G);
                this.oDomContainer.removeChild(G);
            }
            C.removeClass(this.oDomContainer, "withtitle");
        },
        createCloseButton: function () {
            var J = YAHOO.widget.CalendarGroup.CSS_2UPCLOSE, L = "us/my/bn/x_d.gif",
                K = C.getElementsByClassName("link-close", "a", this.oDomContainer)[0],
                G = this.cfg.getProperty(B.STRINGS.key), H = (G && G.close) ? G.close : "";
            if (!K) {
                K = document.createElement("a");
                A.addListener(K, "click", function (N, M) {
                    M.hide();
                    A.preventDefault(N);
                }, this);
            }
            K.href = "#";
            K.className = "link-close";
            if (F.IMG_ROOT !== null) {
                var I = C.getElementsByClassName(J, "img", K)[0] || document.createElement("img");
                I.src = F.IMG_ROOT + L;
                I.className = J;
                K.appendChild(I);
            } else {
                K.innerHTML = '<span class="' + J + " " + this.Style.CSS_CLOSE + '">' + H + "</span>";
            }
            this.oDomContainer.appendChild(K);
            return K;
        },
        removeCloseButton: function () {
            var G = C.getElementsByClassName("link-close", "a", this.oDomContainer)[0] || null;
            if (G) {
                A.purgeElement(G);
                this.oDomContainer.removeChild(G);
            }
        },
        renderHeader: function (Q) {
            var P = 7, O = "us/tr/callt.gif", G = "us/tr/calrt.gif", N = this.cfg, K = N.getProperty(B.PAGEDATE.key),
                L = N.getProperty(B.STRINGS.key), V = (L && L.previousMonth) ? L.previousMonth : "",
                H = (L && L.nextMonth) ? L.nextMonth : "", M;
            if (N.getProperty(B.SHOW_WEEK_HEADER.key)) {
                P += 1;
            }
            if (N.getProperty(B.SHOW_WEEK_FOOTER.key)) {
                P += 1;
            }
            Q[Q.length] = "<thead>";
            Q[Q.length] = "<tr>";
            Q[Q.length] = '<th colspan="' + P + '" class="' + this.Style.CSS_HEADER_TEXT + '">';
            Q[Q.length] = '<div class="' + this.Style.CSS_HEADER + '">';
            var X, U = false;
            if (this.parent) {
                if (this.index === 0) {
                    X = true;
                }
                if (this.index == (this.parent.cfg.getProperty("pages") - 1)) {
                    U = true;
                }
            } else {
                X = true;
                U = true;
            }
            if (X) {
                M = this._buildMonthLabel(D.subtract(K, D.MONTH, 1));
                var R = N.getProperty(B.NAV_ARROW_LEFT.key);
                if (R === null && F.IMG_ROOT !== null) {
                    R = F.IMG_ROOT + O;
                }
                var I = (R === null) ? "" : ' style="background-image:url(' + R + ')"';
                Q[Q.length] = '<a class="' + this.Style.CSS_NAV_LEFT + '"' + I + ' href="#">' + V + " (" + M + ")" + "</a>";
            }
            var W = this.buildMonthLabel();
            var S = this.parent || this;
            if (S.cfg.getProperty("navigator")) {
                W = '<a class="' + this.Style.CSS_NAV + '" href="#">' + W + "</a>";
            }
            Q[Q.length] = W;
            if (U) {
                M = this._buildMonthLabel(D.add(K, D.MONTH, 1));
                var T = N.getProperty(B.NAV_ARROW_RIGHT.key);
                if (T === null && F.IMG_ROOT !== null) {
                    T = F.IMG_ROOT + G;
                }
                var J = (T === null) ? "" : ' style="background-image:url(' + T + ')"';
                Q[Q.length] = '<a class="' + this.Style.CSS_NAV_RIGHT + '"' + J + ' href="#">' + H + " (" + M + ")" + "</a>";
            }
            Q[Q.length] = "</div>\n</th>\n</tr>";
            if (N.getProperty(B.SHOW_WEEKDAYS.key)) {
                Q = this.buildWeekdays(Q);
            }
            Q[Q.length] = "</thead>";
            return Q;
        },
        buildWeekdays: function (H) {
            H[H.length] = '<tr class="' + this.Style.CSS_WEEKDAY_ROW + '">';
            if (this.cfg.getProperty(B.SHOW_WEEK_HEADER.key)) {
                H[H.length] = "<th>&#160;</th>";
            }
            for (var G = 0; G < this.Locale.LOCALE_WEEKDAYS.length; ++G) {
                H[H.length] = '<th class="calweekdaycell">' + this.Locale.LOCALE_WEEKDAYS[G] + "</th>";
            }
            if (this.cfg.getProperty(B.SHOW_WEEK_FOOTER.key)) {
                H[H.length] = "<th>&#160;</th>";
            }
            H[H.length] = "</tr>";
            return H;
        },
        renderBody: function (l, j) {
            var AJ = this.cfg.getProperty(B.START_WEEKDAY.key);
            this.preMonthDays = l.getDay();
            if (AJ > 0) {
                this.preMonthDays -= AJ;
            }
            if (this.preMonthDays < 0) {
                this.preMonthDays += 7;
            }
            this.monthDays = D.findMonthEnd(l).getDate();
            this.postMonthDays = F.DISPLAY_DAYS - this.preMonthDays - this.monthDays;
            l = D.subtract(l, D.DAY, this.preMonthDays);
            var X, N, M = "w", e = "_cell", b = "wd", v = "d", P, q, AB = this.today, O = this.cfg,
                V = AB.getFullYear(), u = AB.getMonth(), J = AB.getDate(), AA = O.getProperty(B.PAGEDATE.key),
                I = O.getProperty(B.HIDE_BLANK_WEEKS.key), h = O.getProperty(B.SHOW_WEEK_FOOTER.key),
                a = O.getProperty(B.SHOW_WEEK_HEADER.key), T = O.getProperty(B.MINDATE.key),
                Z = O.getProperty(B.MAXDATE.key);
            if (T) {
                T = D.clearTime(T);
            }
            if (Z) {
                Z = D.clearTime(Z);
            }
            j[j.length] = '<tbody class="m' + (AA.getMonth() + 1) + " " + this.Style.CSS_BODY + '">';
            var AH = 0, Q = document.createElement("div"), k = document.createElement("td");
            Q.appendChild(k);
            var z = this.parent || this;
            for (var AD = 0; AD < 6; AD++) {
                X = D.getWeekNumber(l, AJ);
                N = M + X;
                if (AD !== 0 && I === true && l.getMonth() != AA.getMonth()) {
                    break;
                } else {
                    j[j.length] = '<tr class="' + N + '">';
                    if (a) {
                        j = this.renderRowHeader(X, j);
                    }
                    for (var AI = 0; AI < 7; AI++) {
                        P = [];
                        this.clearElement(k);
                        k.className = this.Style.CSS_CELL;
                        k.id = this.id + e + AH;
                        if (l.getDate() == J && l.getMonth() == u && l.getFullYear() == V) {
                            P[P.length] = z.renderCellStyleToday;
                        }
                        var Y = [l.getFullYear(), l.getMonth() + 1, l.getDate()];
                        this.cellDates[this.cellDates.length] = Y;
                        if (l.getMonth() != AA.getMonth()) {
                            P[P.length] = z.renderCellNotThisMonth;
                        } else {
                            C.addClass(k, b + l.getDay());
                            C.addClass(k, v + l.getDate());
                            for (var AC = 0; AC < this.renderStack.length; ++AC) {
                                q = null;
                                var w = this.renderStack[AC], AK = w[0], H, c, L;
                                switch (AK) {
                                    case F.DATE:
                                        H = w[1][1];
                                        c = w[1][2];
                                        L = w[1][0];
                                        if (l.getMonth() + 1 == H && l.getDate() == c && l.getFullYear() == L) {
                                            q = w[2];
                                            this.renderStack.splice(AC, 1);
                                        }
                                        break;
                                    case F.MONTH_DAY:
                                        H = w[1][0];
                                        c = w[1][1];
                                        if (l.getMonth() + 1 == H && l.getDate() == c) {
                                            q = w[2];
                                            this.renderStack.splice(AC, 1);
                                        }
                                        break;
                                    case F.RANGE:
                                        var g = w[1][0], f = w[1][1], m = g[1], S = g[2], W = g[0],
                                            AG = D.getDate(W, m - 1, S), K = f[1], o = f[2], G = f[0],
                                            AF = D.getDate(G, K - 1, o);
                                        if (l.getTime() >= AG.getTime() && l.getTime() <= AF.getTime()) {
                                            q = w[2];
                                            if (l.getTime() == AF.getTime()) {
                                                this.renderStack.splice(AC, 1);
                                            }
                                        }
                                        break;
                                    case F.WEEKDAY:
                                        var R = w[1][0];
                                        if (l.getDay() + 1 == R) {
                                            q = w[2];
                                        }
                                        break;
                                    case F.MONTH:
                                        H = w[1][0];
                                        if (l.getMonth() + 1 == H) {
                                            q = w[2];
                                        }
                                        break;
                                }
                                if (q) {
                                    P[P.length] = q;
                                }
                            }
                        }
                        if (this._indexOfSelectedFieldArray(Y) > -1) {
                            P[P.length] = z.renderCellStyleSelected;
                        }
                        if ((T && (l.getTime() < T.getTime())) || (Z && (l.getTime() > Z.getTime()))) {
                            P[P.length] = z.renderOutOfBoundsDate;
                        } else {
                            P[P.length] = z.styleCellDefault;
                            P[P.length] = z.renderCellDefault;
                        }
                        for (var y = 0;
                             y < P.length; ++y) {
                            if (P[y].call(z, l, k) == F.STOP_RENDER) {
                                break;
                            }
                        }
                        l.setTime(l.getTime() + D.ONE_DAY_MS);
                        l = D.clearTime(l);
                        if (AH >= 0 && AH <= 6) {
                            C.addClass(k, this.Style.CSS_CELL_TOP);
                        }
                        if ((AH % 7) === 0) {
                            C.addClass(k, this.Style.CSS_CELL_LEFT);
                        }
                        if (((AH + 1) % 7) === 0) {
                            C.addClass(k, this.Style.CSS_CELL_RIGHT);
                        }
                        var n = this.postMonthDays;
                        if (I && n >= 7) {
                            var U = Math.floor(n / 7);
                            for (var AE = 0; AE < U; ++AE) {
                                n -= 7;
                            }
                        }
                        if (AH >= ((this.preMonthDays + n + this.monthDays) - 7)) {
                            C.addClass(k, this.Style.CSS_CELL_BOTTOM);
                        }
                        j[j.length] = Q.innerHTML;
                        AH++;
                    }
                    if (h) {
                        j = this.renderRowFooter(X, j);
                    }
                    j[j.length] = "</tr>";
                }
            }
            j[j.length] = "</tbody>";
            return j;
        },
        renderFooter: function (G) {
            return G;
        },
        render: function () {
            this.beforeRenderEvent.fire();
            var H = D.findMonthStart(this.cfg.getProperty(B.PAGEDATE.key));
            this.resetRenderers();
            this.cellDates.length = 0;
            A.purgeElement(this.oDomContainer, true);
            var G = [];
            G[G.length] = '<table cellSpacing="0" class="' + this.Style.CSS_CALENDAR + " y" + H.getFullYear() + '" id="' + this.id + '">';
            G = this.renderHeader(G);
            G = this.renderBody(H, G);
            G = this.renderFooter(G);
            G[G.length] = "</table>";
            this.oDomContainer.innerHTML = G.join("\n");
            this.applyListeners();
            this.cells = this.oDomContainer.getElementsByTagName("td");
            this.cfg.refireEvent(B.TITLE.key);
            this.cfg.refireEvent(B.CLOSE.key);
            this.cfg.refireEvent(B.IFRAME.key);
            this.renderEvent.fire();
        },
        applyListeners: function () {
            var P = this.oDomContainer, H = this.parent || this, L = "a", S = "click";
            var M = C.getElementsByClassName(this.Style.CSS_NAV_LEFT, L, P),
                I = C.getElementsByClassName(this.Style.CSS_NAV_RIGHT, L, P);
            if (M && M.length > 0) {
                this.linkLeft = M[0];
                A.addListener(this.linkLeft, S, this.doPreviousMonthNav, H, true);
            }
            if (I && I.length > 0) {
                this.linkRight = I[0];
                A.addListener(this.linkRight, S, this.doNextMonthNav, H, true);
            }
            if (H.cfg.getProperty("navigator") !== null) {
                this.applyNavListeners();
            }
            if (this.domEventMap) {
                var J, G;
                for (var R in this.domEventMap) {
                    if (E.hasOwnProperty(this.domEventMap, R)) {
                        var N = this.domEventMap[R];
                        if (!(N instanceof Array)) {
                            N = [N];
                        }
                        for (var K = 0; K < N.length; K++) {
                            var Q = N[K];
                            G = C.getElementsByClassName(R, Q.tag, this.oDomContainer);
                            for (var O = 0; O < G.length; O++) {
                                J = G[O];
                                A.addListener(J, Q.event, Q.handler, Q.scope, Q.correct);
                            }
                        }
                    }
                }
            }
            A.addListener(this.oDomContainer, "click", this.doSelectCell, this);
            A.addListener(this.oDomContainer, "mouseover", this.doCellMouseOver, this);
            A.addListener(this.oDomContainer, "mouseout", this.doCellMouseOut, this);
        },
        applyNavListeners: function () {
            var H = this.parent || this, I = this,
                G = C.getElementsByClassName(this.Style.CSS_NAV, "a", this.oDomContainer);
            if (G.length > 0) {
                A.addListener(G, "click", function (N, M) {
                    var L = A.getTarget(N);
                    if (this === L || C.isAncestor(this, L)) {
                        A.preventDefault(N);
                    }
                    var J = H.oNavigator;
                    if (J) {
                        var K = I.cfg.getProperty("pagedate");
                        J.setYear(K.getFullYear());
                        J.setMonth(K.getMonth());
                        J.show();
                    }
                });
            }
        },
        getDateByCellId: function (H) {
            var G = this.getDateFieldsByCellId(H);
            return (G) ? D.getDate(G[0], G[1] - 1, G[2]) : null;
        },
        getDateFieldsByCellId: function (G) {
            G = this.getIndexFromId(G);
            return (G > -1) ? this.cellDates[G] : null;
        },
        getCellIndex: function (I) {
            var H = -1;
            if (I) {
                var G = I.getMonth(), N = I.getFullYear(), M = I.getDate(), K = this.cellDates;
                for (var J = 0; J < K.length; ++J) {
                    var L = K[J];
                    if (L[0] === N && L[1] === G + 1 && L[2] === M) {
                        H = J;
                        break;
                    }
                }
            }
            return H;
        },
        getIndexFromId: function (I) {
            var H = -1, G = I.lastIndexOf("_cell");
            if (G > -1) {
                H = parseInt(I.substring(G + 5), 10);
            }
            return H;
        },
        renderOutOfBoundsDate: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_OOB);
            G.innerHTML = H.getDate();
            return F.STOP_RENDER;
        },
        renderRowHeader: function (H, G) {
            G[G.length] = '<th class="calrowhead">' + H + "</th>";
            return G;
        },
        renderRowFooter: function (H, G) {
            G[G.length] = '<th class="calrowfoot">' + H + "</th>";
            return G;
        },
        renderCellDefault: function (H, G) {
            G.innerHTML = '<a href="#" class="' + this.Style.CSS_CELL_SELECTOR + '">' + this.buildDayLabel(H) + "</a>";
        },
        styleCellDefault: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_SELECTABLE);
        },
        renderCellStyleHighlight1: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_HIGHLIGHT1);
        },
        renderCellStyleHighlight2: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_HIGHLIGHT2);
        },
        renderCellStyleHighlight3: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_HIGHLIGHT3);
        },
        renderCellStyleHighlight4: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_HIGHLIGHT4);
        },
        renderCellStyleToday: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_TODAY);
        },
        renderCellStyleSelected: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_SELECTED);
        },
        renderCellNotThisMonth: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL_OOM);
            G.innerHTML = H.getDate();
            return F.STOP_RENDER;
        },
        renderBodyCellRestricted: function (H, G) {
            C.addClass(G, this.Style.CSS_CELL);
            C.addClass(G, this.Style.CSS_CELL_RESTRICTED);
            G.innerHTML = H.getDate();
            return F.STOP_RENDER;
        },
        addMonths: function (H) {
            var G = B.PAGEDATE.key;
            this.cfg.setProperty(G, D.add(this.cfg.getProperty(G), D.MONTH, H));
            this.resetRenderers();
            this.changePageEvent.fire();
        },
        subtractMonths: function (H) {
            var G = B.PAGEDATE.key;
            this.cfg.setProperty(G, D.subtract(this.cfg.getProperty(G), D.MONTH, H));
            this.resetRenderers();
            this.changePageEvent.fire();
        },
        addYears: function (H) {
            var G = B.PAGEDATE.key;
            this.cfg.setProperty(G, D.add(this.cfg.getProperty(G), D.YEAR, H));
            this.resetRenderers();
            this.changePageEvent.fire();
        },
        subtractYears: function (H) {
            var G = B.PAGEDATE.key;
            this.cfg.setProperty(G, D.subtract(this.cfg.getProperty(G), D.YEAR, H));
            this.resetRenderers();
            this.changePageEvent.fire();
        },
        nextMonth: function () {
            this.addMonths(1);
        },
        previousMonth: function () {
            this.subtractMonths(1);
        },
        nextYear: function () {
            this.addYears(1);
        },
        previousYear: function () {
            this.subtractYears(1);
        },
        reset: function () {
            this.cfg.resetProperty(B.SELECTED.key);
            this.cfg.resetProperty(B.PAGEDATE.key);
            this.resetEvent.fire();
        },
        clear: function () {
            this.cfg.setProperty(B.SELECTED.key, []);
            this.cfg.setProperty(B.PAGEDATE.key, new Date(this.today.getTime()));
            this.clearEvent.fire();
        },
        select: function (I) {
            var L = this._toFieldArray(I), H = [], K = [], M = B.SELECTED.key;
            for (var G = 0; G < L.length; ++G) {
                var J = L[G];
                if (!this.isDateOOB(this._toDate(J))) {
                    if (H.length === 0) {
                        this.beforeSelectEvent.fire();
                        K = this.cfg.getProperty(M);
                    }
                    H.push(J);
                    if (this._indexOfSelectedFieldArray(J) == -1) {
                        K[K.length] = J;
                    }
                }
            }
            if (H.length > 0) {
                if (this.parent) {
                    this.parent.cfg.setProperty(M, K);
                } else {
                    this.cfg.setProperty(M, K);
                }
                this.selectEvent.fire(H);
            }
            return this.getSelectedDates();
        },
        selectCell: function (J) {
            var H = this.cells[J], N = this.cellDates[J], M = this._toDate(N),
                I = C.hasClass(H, this.Style.CSS_CELL_SELECTABLE);
            if (I) {
                this.beforeSelectEvent.fire();
                var L = B.SELECTED.key;
                var K = this.cfg.getProperty(L);
                var G = N.concat();
                if (this._indexOfSelectedFieldArray(G) == -1) {
                    K[K.length] = G;
                }
                if (this.parent) {
                    this.parent.cfg.setProperty(L, K);
                } else {
                    this.cfg.setProperty(L, K);
                }
                this.renderCellStyleSelected(M, H);
                this.selectEvent.fire([G]);
                this.doCellMouseOut.call(H, null, this);
            }
            return this.getSelectedDates();
        },
        deselect: function (K) {
            var G = this._toFieldArray(K), J = [], M = [], N = B.SELECTED.key;
            for (var H = 0; H < G.length; ++H) {
                var L = G[H];
                if (!this.isDateOOB(this._toDate(L))) {
                    if (J.length === 0) {
                        this.beforeDeselectEvent.fire();
                        M = this.cfg.getProperty(N);
                    }
                    J.push(L);
                    var I = this._indexOfSelectedFieldArray(L);
                    if (I != -1) {
                        M.splice(I, 1);
                    }
                }
            }
            if (J.length > 0) {
                if (this.parent) {
                    this.parent.cfg.setProperty(N, M);
                } else {
                    this.cfg.setProperty(N, M);
                }
                this.deselectEvent.fire(J);
            }
            return this.getSelectedDates();
        },
        deselectCell: function (K) {
            var H = this.cells[K], N = this.cellDates[K], I = this._indexOfSelectedFieldArray(N);
            var J = C.hasClass(H, this.Style.CSS_CELL_SELECTABLE);
            if (J) {
                this.beforeDeselectEvent.fire();
                var L = this.cfg.getProperty(B.SELECTED.key), M = this._toDate(N), G = N.concat();
                if (I > -1) {
                    if (this.cfg.getProperty(B.PAGEDATE.key).getMonth() == M.getMonth() && this.cfg.getProperty(B.PAGEDATE.key).getFullYear() == M.getFullYear()) {
                        C.removeClass(H, this.Style.CSS_CELL_SELECTED);
                    }
                    L.splice(I, 1);
                }
                if (this.parent) {
                    this.parent.cfg.setProperty(B.SELECTED.key, L);
                } else {
                    this.cfg.setProperty(B.SELECTED.key, L);
                }
                this.deselectEvent.fire([G]);
            }
            return this.getSelectedDates();
        },
        deselectAll: function () {
            this.beforeDeselectEvent.fire();
            var J = B.SELECTED.key, G = this.cfg.getProperty(J), H = G.length, I = G.concat();
            if (this.parent) {
                this.parent.cfg.setProperty(J, []);
            } else {
                this.cfg.setProperty(J, []);
            }
            if (H > 0) {
                this.deselectEvent.fire(I);
            }
            return this.getSelectedDates();
        },
        _toFieldArray: function (H) {
            var G = [];
            if (H instanceof Date) {
                G = [[H.getFullYear(), H.getMonth() + 1, H.getDate()]];
            } else {
                if (E.isString(H)) {
                    G = this._parseDates(H);
                } else {
                    if (E.isArray(H)) {
                        for (var I = 0; I < H.length; ++I) {
                            var J = H[I];
                            G[G.length] = [J.getFullYear(), J.getMonth() + 1, J.getDate()];
                        }
                    }
                }
            }
            return G;
        },
        toDate: function (G) {
            return this._toDate(G);
        },
        _toDate: function (G) {
            if (G instanceof Date) {
                return G;
            } else {
                return D.getDate(G[0], G[1] - 1, G[2]);
            }
        },
        _fieldArraysAreEqual: function (I, H) {
            var G = false;
            if (I[0] == H[0] && I[1] == H[1] && I[2] == H[2]) {
                G = true;
            }
            return G;
        },
        _indexOfSelectedFieldArray: function (K) {
            var J = -1, G = this.cfg.getProperty(B.SELECTED.key);
            for (var I = 0; I < G.length; ++I) {
                var H = G[I];
                if (K[0] == H[0] && K[1] == H[1] && K[2] == H[2]) {
                    J = I;
                    break;
                }
            }
            return J;
        },
        isDateOOM: function (G) {
            return (G.getMonth() != this.cfg.getProperty(B.PAGEDATE.key).getMonth());
        },
        isDateOOB: function (I) {
            var J = this.cfg.getProperty(B.MINDATE.key), K = this.cfg.getProperty(B.MAXDATE.key), H = D;
            if (J) {
                J = H.clearTime(J);
            }
            if (K) {
                K = H.clearTime(K);
            }
            var G = new Date(I.getTime());
            G = H.clearTime(G);
            return ((J && G.getTime() < J.getTime()) || (K && G.getTime() > K.getTime()));
        },
        _parsePageDate: function (G) {
            var J;
            if (G) {
                if (G instanceof Date) {
                    J = D.findMonthStart(G);
                } else {
                    var K, I, H;
                    H = G.split(this.cfg.getProperty(B.DATE_FIELD_DELIMITER.key));
                    K = parseInt(H[this.cfg.getProperty(B.MY_MONTH_POSITION.key) - 1], 10) - 1;
                    I = parseInt(H[this.cfg.getProperty(B.MY_YEAR_POSITION.key) - 1], 10);
                    J = D.getDate(I, K, 1);
                }
            } else {
                J = D.getDate(this.today.getFullYear(), this.today.getMonth(), 1);
            }
            return J;
        },
        onBeforeSelect: function () {
            if (this.cfg.getProperty(B.MULTI_SELECT.key) === false) {
                if (this.parent) {
                    this.parent.callChildFunction("clearAllBodyCellStyles", this.Style.CSS_CELL_SELECTED);
                    this.parent.deselectAll();
                } else {
                    this.clearAllBodyCellStyles(this.Style.CSS_CELL_SELECTED);
                    this.deselectAll();
                }
            }
        },
        onSelect: function (G) {
        },
        onBeforeDeselect: function () {
        },
        onDeselect: function (G) {
        },
        onChangePage: function () {
            this.render();
        },
        onRender: function () {
        },
        onReset: function () {
            this.render();
        },
        onClear: function () {
            this.render();
        },
        validate: function () {
            return true;
        },
        _parseDate: function (I) {
            var J = I.split(this.Locale.DATE_FIELD_DELIMITER), G;
            if (J.length == 2) {
                G = [J[this.Locale.MD_MONTH_POSITION - 1], J[this.Locale.MD_DAY_POSITION - 1]];
                G.type = F.MONTH_DAY;
            } else {
                G = [J[this.Locale.MDY_YEAR_POSITION - 1], J[this.Locale.MDY_MONTH_POSITION - 1], J[this.Locale.MDY_DAY_POSITION - 1]];
                G.type = F.DATE;
            }
            for (var H = 0; H < G.length; H++) {
                G[H] = parseInt(G[H], 10);
            }
            return G;
        },
        _parseDates: function (H) {
            var O = [], N = H.split(this.Locale.DATE_DELIMITER);
            for (var M = 0; M < N.length; ++M) {
                var L = N[M];
                if (L.indexOf(this.Locale.DATE_RANGE_DELIMITER) != -1) {
                    var G = L.split(this.Locale.DATE_RANGE_DELIMITER), K = this._parseDate(G[0]),
                        P = this._parseDate(G[1]), J = this._parseRange(K, P);
                    O = O.concat(J);
                } else {
                    var I = this._parseDate(L);
                    O.push(I);
                }
            }
            return O;
        },
        _parseRange: function (G, K) {
            var H = D.add(D.getDate(G[0], G[1] - 1, G[2]), D.DAY, 1), J = D.getDate(K[0], K[1] - 1, K[2]), I = [];
            I.push(G);
            while (H.getTime() <= J.getTime()) {
                I.push([H.getFullYear(), H.getMonth() + 1, H.getDate()]);
                H = D.add(H, D.DAY, 1);
            }
            return I;
        },
        resetRenderers: function () {
            this.renderStack = this._renderStack.concat();
        },
        removeRenderers: function () {
            this._renderStack = [];
            this.renderStack = [];
        },
        clearElement: function (G) {
            G.innerHTML = "&#160;";
            G.className = "";
        },
        addRenderer: function (G, H) {
            var J = this._parseDates(G);
            for (var I = 0; I < J.length; ++I) {
                var K = J[I];
                if (K.length == 2) {
                    if (K[0] instanceof Array) {
                        this._addRenderer(F.RANGE, K, H);
                    } else {
                        this._addRenderer(F.MONTH_DAY, K, H);
                    }
                } else {
                    if (K.length == 3) {
                        this._addRenderer(F.DATE, K, H);
                    }
                }
            }
        },
        _addRenderer: function (H, I, G) {
            var J = [H, I, G];
            this.renderStack.unshift(J);
            this._renderStack = this.renderStack.concat();
        },
        addMonthRenderer: function (H, G) {
            this._addRenderer(F.MONTH, [H], G);
        },
        addWeekdayRenderer: function (H, G) {
            this._addRenderer(F.WEEKDAY, [H], G);
        },
        clearAllBodyCellStyles: function (G) {
            for (var H = 0; H < this.cells.length; ++H) {
                C.removeClass(this.cells[H], G);
            }
        },
        setMonth: function (I) {
            var G = B.PAGEDATE.key, H = this.cfg.getProperty(G);
            H.setMonth(parseInt(I, 10));
            this.cfg.setProperty(G, H);
        },
        setYear: function (H) {
            var G = B.PAGEDATE.key, I = this.cfg.getProperty(G);
            I.setFullYear(parseInt(H, 10));
            this.cfg.setProperty(G, I);
        },
        getSelectedDates: function () {
            var I = [], H = this.cfg.getProperty(B.SELECTED.key);
            for (var K = 0; K < H.length; ++K) {
                var J = H[K];
                var G = D.getDate(J[0], J[1] - 1, J[2]);
                I.push(G);
            }
            I.sort(function (M, L) {
                return M - L;
            });
            return I;
        },
        hide: function () {
            if (this.beforeHideEvent.fire()) {
                this.oDomContainer.style.display = "none";
                this.hideEvent.fire();
            }
        },
        show: function () {
            if (this.beforeShowEvent.fire()) {
                this.oDomContainer.style.display = "block";
                this.showEvent.fire();
            }
        },
        browser: (function () {
            var G = navigator.userAgent.toLowerCase();
            if (G.indexOf("opera") != -1) {
                return "opera";
            } else {
                if (G.indexOf("msie 7") != -1) {
                    return "ie7";
                } else {
                    if (G.indexOf("msie") != -1) {
                        return "ie";
                    } else {
                        if (G.indexOf("safari") != -1) {
                            return "safari";
                        } else {
                            if (G.indexOf("gecko") != -1) {
                                return "gecko";
                            } else {
                                return false;
                            }
                        }
                    }
                }
            }
        })(),
        toString: function () {
            return "Calendar " + this.id;
        },
        destroy: function () {
            if (this.beforeDestroyEvent.fire()) {
                var G = this;
                if (G.navigator) {
                    G.navigator.destroy();
                }
                if (G.cfg) {
                    G.cfg.destroy();
                }
                A.purgeElement(G.oDomContainer, true);
                C.removeClass(G.oDomContainer, "withtitle");
                C.removeClass(G.oDomContainer, G.Style.CSS_CONTAINER);
                C.removeClass(G.oDomContainer, G.Style.CSS_SINGLE);
                G.oDomContainer.innerHTML = "";
                G.oDomContainer = null;
                G.cells = null;
                this.destroyEvent.fire();
            }
        }
    };
    YAHOO.widget.Calendar = F;
    YAHOO.widget.Calendar_Core = YAHOO.widget.Calendar;
    YAHOO.widget.Cal_Core = YAHOO.widget.Calendar;
})();
(function () {
    var D = YAHOO.util.Dom, F = YAHOO.widget.DateMath, A = YAHOO.util.Event, E = YAHOO.lang, G = YAHOO.widget.Calendar;

    function B(J, H, I) {
        if (arguments.length > 0) {
            this.init.apply(this, arguments);
        }
    }

    B._DEFAULT_CONFIG = G._DEFAULT_CONFIG;
    B._DEFAULT_CONFIG.PAGES = {key: "pages", value: 2};
    var C = B._DEFAULT_CONFIG;
    B.prototype = {
        init: function (K, I, J) {
            var H = this._parseArgs(arguments);
            K = H.id;
            I = H.container;
            J = H.config;
            this.oDomContainer = D.get(I);
            if (!this.oDomContainer.id) {
                this.oDomContainer.id = D.generateId();
            }
            if (!K) {
                K = this.oDomContainer.id + "_t";
            }
            this.id = K;
            this.containerId = this.oDomContainer.id;
            this.initEvents();
            this.initStyles();
            this.pages = [];
            D.addClass(this.oDomContainer, B.CSS_CONTAINER);
            D.addClass(this.oDomContainer, B.CSS_MULTI_UP);
            this.cfg = new YAHOO.util.Config(this);
            this.Options = {};
            this.Locale = {};
            this.setupConfig();
            if (J) {
                this.cfg.applyConfig(J, true);
            }
            this.cfg.fireQueue();
            if (YAHOO.env.ua.opera) {
                this.renderEvent.subscribe(this._fixWidth, this, true);
                this.showEvent.subscribe(this._fixWidth, this, true);
            }
        }, setupConfig: function () {
            var H = this.cfg;
            H.addProperty(C.PAGES.key, {value: C.PAGES.value, validator: H.checkNumber, handler: this.configPages});
            H.addProperty(C.PAGEDATE.key, {value: new Date(), handler: this.configPageDate});
            H.addProperty(C.SELECTED.key, {value: [], handler: this.configSelected});
            H.addProperty(C.TITLE.key, {value: C.TITLE.value, handler: this.configTitle});
            H.addProperty(C.CLOSE.key, {value: C.CLOSE.value, handler: this.configClose});
            H.addProperty(C.IFRAME.key, {value: C.IFRAME.value, handler: this.configIframe, validator: H.checkBoolean});
            H.addProperty(C.MINDATE.key, {value: C.MINDATE.value, handler: this.delegateConfig});
            H.addProperty(C.MAXDATE.key, {value: C.MAXDATE.value, handler: this.delegateConfig});
            H.addProperty(C.MULTI_SELECT.key, {
                value: C.MULTI_SELECT.value,
                handler: this.delegateConfig,
                validator: H.checkBoolean
            });
            H.addProperty(C.START_WEEKDAY.key, {
                value: C.START_WEEKDAY.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.SHOW_WEEKDAYS.key, {
                value: C.SHOW_WEEKDAYS.value,
                handler: this.delegateConfig,
                validator: H.checkBoolean
            });
            H.addProperty(C.SHOW_WEEK_HEADER.key, {
                value: C.SHOW_WEEK_HEADER.value,
                handler: this.delegateConfig,
                validator: H.checkBoolean
            });
            H.addProperty(C.SHOW_WEEK_FOOTER.key, {
                value: C.SHOW_WEEK_FOOTER.value,
                handler: this.delegateConfig,
                validator: H.checkBoolean
            });
            H.addProperty(C.HIDE_BLANK_WEEKS.key, {
                value: C.HIDE_BLANK_WEEKS.value,
                handler: this.delegateConfig,
                validator: H.checkBoolean
            });
            H.addProperty(C.NAV_ARROW_LEFT.key, {value: C.NAV_ARROW_LEFT.value, handler: this.delegateConfig});
            H.addProperty(C.NAV_ARROW_RIGHT.key, {value: C.NAV_ARROW_RIGHT.value, handler: this.delegateConfig});
            H.addProperty(C.MONTHS_SHORT.key, {value: C.MONTHS_SHORT.value, handler: this.delegateConfig});
            H.addProperty(C.MONTHS_LONG.key, {value: C.MONTHS_LONG.value, handler: this.delegateConfig});
            H.addProperty(C.WEEKDAYS_1CHAR.key, {value: C.WEEKDAYS_1CHAR.value, handler: this.delegateConfig});
            H.addProperty(C.WEEKDAYS_SHORT.key, {value: C.WEEKDAYS_SHORT.value, handler: this.delegateConfig});
            H.addProperty(C.WEEKDAYS_MEDIUM.key, {value: C.WEEKDAYS_MEDIUM.value, handler: this.delegateConfig});
            H.addProperty(C.WEEKDAYS_LONG.key, {value: C.WEEKDAYS_LONG.value, handler: this.delegateConfig});
            H.addProperty(C.LOCALE_MONTHS.key, {value: C.LOCALE_MONTHS.value, handler: this.delegateConfig});
            H.addProperty(C.LOCALE_WEEKDAYS.key, {value: C.LOCALE_WEEKDAYS.value, handler: this.delegateConfig});
            H.addProperty(C.DATE_DELIMITER.key, {value: C.DATE_DELIMITER.value, handler: this.delegateConfig});
            H.addProperty(C.DATE_FIELD_DELIMITER.key, {
                value: C.DATE_FIELD_DELIMITER.value,
                handler: this.delegateConfig
            });
            H.addProperty(C.DATE_RANGE_DELIMITER.key, {
                value: C.DATE_RANGE_DELIMITER.value,
                handler: this.delegateConfig
            });
            H.addProperty(C.MY_MONTH_POSITION.key, {
                value: C.MY_MONTH_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MY_YEAR_POSITION.key, {
                value: C.MY_YEAR_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MD_MONTH_POSITION.key, {
                value: C.MD_MONTH_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MD_DAY_POSITION.key, {
                value: C.MD_DAY_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MDY_MONTH_POSITION.key, {
                value: C.MDY_MONTH_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MDY_DAY_POSITION.key, {
                value: C.MDY_DAY_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MDY_YEAR_POSITION.key, {
                value: C.MDY_YEAR_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MY_LABEL_MONTH_POSITION.key, {
                value: C.MY_LABEL_MONTH_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MY_LABEL_YEAR_POSITION.key, {
                value: C.MY_LABEL_YEAR_POSITION.value,
                handler: this.delegateConfig,
                validator: H.checkNumber
            });
            H.addProperty(C.MY_LABEL_MONTH_SUFFIX.key, {
                value: C.MY_LABEL_MONTH_SUFFIX.value,
                handler: this.delegateConfig
            });
            H.addProperty(C.MY_LABEL_YEAR_SUFFIX.key, {
                value: C.MY_LABEL_YEAR_SUFFIX.value,
                handler: this.delegateConfig
            });
            H.addProperty(C.NAV.key, {value: C.NAV.value, handler: this.configNavigator});
            H.addProperty(C.STRINGS.key, {
                value: C.STRINGS.value, handler: this.configStrings, validator: function (I) {
                    return E.isObject(I);
                }, supercedes: C.STRINGS.supercedes
            });
        }, initEvents: function () {
            var J = this, L = "Event", M = YAHOO.util.CustomEvent;
            var I = function (O, R, N) {
                for (var Q = 0; Q < J.pages.length; ++Q) {
                    var P = J.pages[Q];
                    P[this.type + L].subscribe(O, R, N);
                }
            };
            var H = function (N, Q) {
                for (var P = 0; P < J.pages.length; ++P) {
                    var O = J.pages[P];
                    O[this.type + L].unsubscribe(N, Q);
                }
            };
            var K = G._EVENT_TYPES;
            J.beforeSelectEvent = new M(K.BEFORE_SELECT);
            J.beforeSelectEvent.subscribe = I;
            J.beforeSelectEvent.unsubscribe = H;
            J.selectEvent = new M(K.SELECT);
            J.selectEvent.subscribe = I;
            J.selectEvent.unsubscribe = H;
            J.beforeDeselectEvent = new M(K.BEFORE_DESELECT);
            J.beforeDeselectEvent.subscribe = I;
            J.beforeDeselectEvent.unsubscribe = H;
            J.deselectEvent = new M(K.DESELECT);
            J.deselectEvent.subscribe = I;
            J.deselectEvent.unsubscribe = H;
            J.changePageEvent = new M(K.CHANGE_PAGE);
            J.changePageEvent.subscribe = I;
            J.changePageEvent.unsubscribe = H;
            J.beforeRenderEvent = new M(K.BEFORE_RENDER);
            J.beforeRenderEvent.subscribe = I;
            J.beforeRenderEvent.unsubscribe = H;
            J.renderEvent = new M(K.RENDER);
            J.renderEvent.subscribe = I;
            J.renderEvent.unsubscribe = H;
            J.resetEvent = new M(K.RESET);
            J.resetEvent.subscribe = I;
            J.resetEvent.unsubscribe = H;
            J.clearEvent = new M(K.CLEAR);
            J.clearEvent.subscribe = I;
            J.clearEvent.unsubscribe = H;
            J.beforeShowEvent = new M(K.BEFORE_SHOW);
            J.showEvent = new M(K.SHOW);
            J.beforeHideEvent = new M(K.BEFORE_HIDE);
            J.hideEvent = new M(K.HIDE);
            J.beforeShowNavEvent = new M(K.BEFORE_SHOW_NAV);
            J.showNavEvent = new M(K.SHOW_NAV);
            J.beforeHideNavEvent = new M(K.BEFORE_HIDE_NAV);
            J.hideNavEvent = new M(K.HIDE_NAV);
            J.beforeRenderNavEvent = new M(K.BEFORE_RENDER_NAV);
            J.renderNavEvent = new M(K.RENDER_NAV);
            J.beforeDestroyEvent = new M(K.BEFORE_DESTROY);
            J.destroyEvent = new M(K.DESTROY);
        }, configPages: function (T, R, N) {
            var L = R[0], J = C.PAGEDATE.key, W = "_", M, O = null, S = "groupcal", V = "first-of-type",
                K = "last-of-type";
            for (var I = 0; I < L; ++I) {
                var U = this.id + W + I, Q = this.containerId + W + I, P = this.cfg.getConfig();
                P.close = false;
                P.title = false;
                P.navigator = null;
                if (I > 0) {
                    M = new Date(O);
                    this._setMonthOnDate(M, M.getMonth() + I);
                    P.pageDate = M;
                }
                var H = this.constructChild(U, Q, P);
                D.removeClass(H.oDomContainer, this.Style.CSS_SINGLE);
                D.addClass(H.oDomContainer, S);
                if (I === 0) {
                    O = H.cfg.getProperty(J);
                    D.addClass(H.oDomContainer, V);
                }
                if (I == (L - 1)) {
                    D.addClass(H.oDomContainer, K);
                }
                H.parent = this;
                H.index = I;
                this.pages[this.pages.length] = H;
            }
        }, configPageDate: function (O, N, L) {
            var J = N[0], M;
            var K = C.PAGEDATE.key;
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                if (I === 0) {
                    M = H._parsePageDate(J);
                    H.cfg.setProperty(K, M);
                } else {
                    var P = new Date(M);
                    this._setMonthOnDate(P, P.getMonth() + I);
                    H.cfg.setProperty(K, P);
                }
            }
        }, configSelected: function (J, H, L) {
            var K = C.SELECTED.key;
            this.delegateConfig(J, H, L);
            var I = (this.pages.length > 0) ? this.pages[0].cfg.getProperty(K) : [];
            this.cfg.setProperty(K, I, true);
        }, delegateConfig: function (I, H, L) {
            var M = H[0];
            var K;
            for (var J = 0; J < this.pages.length; J++) {
                K = this.pages[J];
                K.cfg.setProperty(I, M);
            }
        }, setChildFunction: function (K, I) {
            var H = this.cfg.getProperty(C.PAGES.key);
            for (var J = 0; J < H; ++J) {
                this.pages[J][K] = I;
            }
        }, callChildFunction: function (M, I) {
            var H = this.cfg.getProperty(C.PAGES.key);
            for (var L = 0; L < H; ++L) {
                var K = this.pages[L];
                if (K[M]) {
                    var J = K[M];
                    J.call(K, I);
                }
            }
        }, constructChild: function (K, I, J) {
            var H = document.getElementById(I);
            if (!H) {
                H = document.createElement("div");
                H.id = I;
                this.oDomContainer.appendChild(H);
            }
            return new G(K, I, J);
        }, setMonth: function (L) {
            L = parseInt(L, 10);
            var M;
            var I = C.PAGEDATE.key;
            for (var K = 0; K < this.pages.length; ++K) {
                var J = this.pages[K];
                var H = J.cfg.getProperty(I);
                if (K === 0) {
                    M = H.getFullYear();
                } else {
                    H.setFullYear(M);
                }
                this._setMonthOnDate(H, L + K);
                J.cfg.setProperty(I, H);
            }
        }, setYear: function (J) {
            var I = C.PAGEDATE.key;
            J = parseInt(J, 10);
            for (var L = 0; L < this.pages.length; ++L) {
                var K = this.pages[L];
                var H = K.cfg.getProperty(I);
                if ((H.getMonth() + 1) == 1 && L > 0) {
                    J += 1;
                }
                K.setYear(J);
            }
        }, render: function () {
            this.renderHeader();
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                H.render();
            }
            this.renderFooter();
        }, select: function (H) {
            for (var J = 0; J < this.pages.length; ++J) {
                var I = this.pages[J];
                I.select(H);
            }
            return this.getSelectedDates();
        }, selectCell: function (H) {
            for (var J = 0; J < this.pages.length; ++J) {
                var I = this.pages[J];
                I.selectCell(H);
            }
            return this.getSelectedDates();
        }, deselect: function (H) {
            for (var J = 0; J < this.pages.length; ++J) {
                var I = this.pages[J];
                I.deselect(H);
            }
            return this.getSelectedDates();
        }, deselectAll: function () {
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                H.deselectAll();
            }
            return this.getSelectedDates();
        }, deselectCell: function (H) {
            for (var J = 0; J < this.pages.length; ++J) {
                var I = this.pages[J];
                I.deselectCell(H);
            }
            return this.getSelectedDates();
        }, reset: function () {
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                H.reset();
            }
        }, clear: function () {
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                H.clear();
            }
            this.cfg.setProperty(C.SELECTED.key, []);
            this.cfg.setProperty(C.PAGEDATE.key, new Date(this.pages[0].today.getTime()));
            this.render();
        }, nextMonth: function () {
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                H.nextMonth();
            }
        }, previousMonth: function () {
            for (var I = this.pages.length - 1; I >= 0; --I) {
                var H = this.pages[I];
                H.previousMonth();
            }
        }, nextYear: function () {
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                H.nextYear();
            }
        }, previousYear: function () {
            for (var I = 0; I < this.pages.length; ++I) {
                var H = this.pages[I];
                H.previousYear();
            }
        }, getSelectedDates: function () {
            var J = [];
            var I = this.cfg.getProperty(C.SELECTED.key);
            for (var L = 0; L < I.length; ++L) {
                var K = I[L];
                var H = F.getDate(K[0], K[1] - 1, K[2]);
                J.push(H);
            }
            J.sort(function (N, M) {
                return N - M;
            });
            return J;
        }, addRenderer: function (H, I) {
            for (var K = 0; K < this.pages.length; ++K) {
                var J = this.pages[K];
                J.addRenderer(H, I);
            }
        }, addMonthRenderer: function (K, H) {
            for (var J = 0; J < this.pages.length; ++J) {
                var I = this.pages[J];
                I.addMonthRenderer(K, H);
            }
        }, addWeekdayRenderer: function (I, H) {
            for (var K = 0; K < this.pages.length; ++K) {
                var J = this.pages[K];
                J.addWeekdayRenderer(I, H);
            }
        }, removeRenderers: function () {
            this.callChildFunction("removeRenderers");
        }, renderHeader: function () {
        }, renderFooter: function () {
        }, addMonths: function (H) {
            this.callChildFunction("addMonths", H);
        }, subtractMonths: function (H) {
            this.callChildFunction("subtractMonths", H);
        }, addYears: function (H) {
            this.callChildFunction("addYears", H);
        }, subtractYears: function (H) {
            this.callChildFunction("subtractYears", H);
        }, getCalendarPage: function (K) {
            var M = null;
            if (K) {
                var N = K.getFullYear(), J = K.getMonth();
                var I = this.pages;
                for (var L = 0; L < I.length; ++L) {
                    var H = I[L].cfg.getProperty("pagedate");
                    if (H.getFullYear() === N && H.getMonth() === J) {
                        M = I[L];
                        break;
                    }
                }
            }
            return M;
        }, _setMonthOnDate: function (I, J) {
            if (YAHOO.env.ua.webkit && YAHOO.env.ua.webkit < 420 && (J < 0 || J > 11)) {
                var H = F.add(I, F.MONTH, J - I.getMonth());
                I.setTime(H.getTime());
            } else {
                I.setMonth(J);
            }
        }, _fixWidth: function () {
            var H = 0;
            for (var J = 0; J < this.pages.length; ++J) {
                var I = this.pages[J];
                H += I.oDomContainer.offsetWidth;
            }
            if (H > 0) {
                this.oDomContainer.style.width = H + "px";
            }
        }, toString: function () {
            return "CalendarGroup " + this.id;
        }, destroy: function () {
            if (this.beforeDestroyEvent.fire()) {
                var J = this;
                if (J.navigator) {
                    J.navigator.destroy();
                }
                if (J.cfg) {
                    J.cfg.destroy();
                }
                A.purgeElement(J.oDomContainer, true);
                D.removeClass(J.oDomContainer, B.CSS_CONTAINER);
                D.removeClass(J.oDomContainer, B.CSS_MULTI_UP);
                for (var I = 0, H = J.pages.length; I < H; I++) {
                    J.pages[I].destroy();
                    J.pages[I] = null;
                }
                J.oDomContainer.innerHTML = "";
                J.oDomContainer = null;
                this.destroyEvent.fire();
            }
        }
    };
    B.CSS_CONTAINER = "yui-calcontainer";
    B.CSS_MULTI_UP = "multi";
    B.CSS_2UPTITLE = "title";
    B.CSS_2UPCLOSE = "close-icon";
    YAHOO.lang.augmentProto(B, G, "buildDayLabel", "buildMonthLabel", "renderOutOfBoundsDate", "renderRowHeader", "renderRowFooter", "renderCellDefault", "styleCellDefault", "renderCellStyleHighlight1", "renderCellStyleHighlight2", "renderCellStyleHighlight3", "renderCellStyleHighlight4", "renderCellStyleToday", "renderCellStyleSelected", "renderCellNotThisMonth", "renderBodyCellRestricted", "initStyles", "configTitle", "configClose", "configIframe", "configStrings", "configNavigator", "createTitleBar", "createCloseButton", "removeTitleBar", "removeCloseButton", "hide", "show", "toDate", "_toDate", "_parseArgs", "browser");
    YAHOO.widget.CalGrp = B;
    YAHOO.widget.CalendarGroup = B;
    YAHOO.widget.Calendar2up = function (J, H, I) {
        this.init(J, H, I);
    };
    YAHOO.extend(YAHOO.widget.Calendar2up, B);
    YAHOO.widget.Cal2up = YAHOO.widget.Calendar2up;
})();
YAHOO.widget.CalendarNavigator = function (A) {
    this.init(A);
};
(function () {
    var A = YAHOO.widget.CalendarNavigator;
    A.CLASSES = {
        NAV: "yui-cal-nav",
        NAV_VISIBLE: "yui-cal-nav-visible",
        MASK: "yui-cal-nav-mask",
        YEAR: "yui-cal-nav-y",
        MONTH: "yui-cal-nav-m",
        BUTTONS: "yui-cal-nav-b",
        BUTTON: "yui-cal-nav-btn",
        ERROR: "yui-cal-nav-e",
        YEAR_CTRL: "yui-cal-nav-yc",
        MONTH_CTRL: "yui-cal-nav-mc",
        INVALID: "yui-invalid",
        DEFAULT: "yui-default"
    };
    A._DEFAULT_CFG = {
        strings: {
            month: "Month",
            year: "Year",
            submit: "Okay",
            cancel: "Cancel",
            invalidYear: "Year needs to be a number"
        }, monthFormat: YAHOO.widget.Calendar.LONG, initialFocus: "year"
    };
    A.ID_SUFFIX = "_nav";
    A.MONTH_SUFFIX = "_month";
    A.YEAR_SUFFIX = "_year";
    A.ERROR_SUFFIX = "_error";
    A.CANCEL_SUFFIX = "_cancel";
    A.SUBMIT_SUFFIX = "_submit";
    A.YR_MAX_DIGITS = 4;
    A.YR_MINOR_INC = 1;
    A.YR_MAJOR_INC = 10;
    A.UPDATE_DELAY = 50;
    A.YR_PATTERN = /^\d+$/;
    A.TRIM = /^\s*(.*?)\s*$/;
})();
YAHOO.widget.CalendarNavigator.prototype = {
    id: null,
    cal: null,
    navEl: null,
    maskEl: null,
    yearEl: null,
    monthEl: null,
    errorEl: null,
    submitEl: null,
    cancelEl: null,
    firstCtrl: null,
    lastCtrl: null,
    _doc: null,
    _year: null,
    _month: 0,
    __rendered: false,
    init: function (A) {
        var C = A.oDomContainer;
        this.cal = A;
        this.id = C.id + YAHOO.widget.CalendarNavigator.ID_SUFFIX;
        this._doc = C.ownerDocument;
        var B = YAHOO.env.ua.ie;
        this.__isIEQuirks = (B && ((B <= 6) || (this._doc.compatMode == "BackCompat")));
    },
    show: function () {
        var A = YAHOO.widget.CalendarNavigator.CLASSES;
        if (this.cal.beforeShowNavEvent.fire()) {
            if (!this.__rendered) {
                this.render();
            }
            this.clearErrors();
            this._updateMonthUI();
            this._updateYearUI();
            this._show(this.navEl, true);
            this.setInitialFocus();
            this.showMask();
            YAHOO.util.Dom.addClass(this.cal.oDomContainer, A.NAV_VISIBLE);
            this.cal.showNavEvent.fire();
        }
    },
    hide: function () {
        var A = YAHOO.widget.CalendarNavigator.CLASSES;
        if (this.cal.beforeHideNavEvent.fire()) {
            this._show(this.navEl, false);
            this.hideMask();
            YAHOO.util.Dom.removeClass(this.cal.oDomContainer, A.NAV_VISIBLE);
            this.cal.hideNavEvent.fire();
        }
    },
    showMask: function () {
        this._show(this.maskEl, true);
        if (this.__isIEQuirks) {
            this._syncMask();
        }
    },
    hideMask: function () {
        this._show(this.maskEl, false);
    },
    getMonth: function () {
        return this._month;
    },
    getYear: function () {
        return this._year;
    },
    setMonth: function (A) {
        if (A >= 0 && A < 12) {
            this._month = A;
        }
        this._updateMonthUI();
    },
    setYear: function (B) {
        var A = YAHOO.widget.CalendarNavigator.YR_PATTERN;
        if (YAHOO.lang.isNumber(B) && A.test(B + "")) {
            this._year = B;
        }
        this._updateYearUI();
    },
    render: function () {
        this.cal.beforeRenderNavEvent.fire();
        if (!this.__rendered) {
            this.createNav();
            this.createMask();
            this.applyListeners();
            this.__rendered = true;
        }
        this.cal.renderNavEvent.fire();
    },
    createNav: function () {
        var B = YAHOO.widget.CalendarNavigator;
        var C = this._doc;
        var D = C.createElement("div");
        D.className = B.CLASSES.NAV;
        var A = this.renderNavContents([]);
        D.innerHTML = A.join("");
        this.cal.oDomContainer.appendChild(D);
        this.navEl = D;
        this.yearEl = C.getElementById(this.id + B.YEAR_SUFFIX);
        this.monthEl = C.getElementById(this.id + B.MONTH_SUFFIX);
        this.errorEl = C.getElementById(this.id + B.ERROR_SUFFIX);
        this.submitEl = C.getElementById(this.id + B.SUBMIT_SUFFIX);
        this.cancelEl = C.getElementById(this.id + B.CANCEL_SUFFIX);
        if (YAHOO.env.ua.gecko && this.yearEl && this.yearEl.type == "text") {
            this.yearEl.setAttribute("autocomplete", "off");
        }
        this._setFirstLastElements();
    },
    createMask: function () {
        var B = YAHOO.widget.CalendarNavigator.CLASSES;
        var A = this._doc.createElement("div");
        A.className = B.MASK;
        this.cal.oDomContainer.appendChild(A);
        this.maskEl = A;
    },
    _syncMask: function () {
        var B = this.cal.oDomContainer;
        if (B && this.maskEl) {
            var A = YAHOO.util.Dom.getRegion(B);
            YAHOO.util.Dom.setStyle(this.maskEl, "width", A.right - A.left + "px");
            YAHOO.util.Dom.setStyle(this.maskEl, "height", A.bottom - A.top + "px");
        }
    },
    renderNavContents: function (A) {
        var D = YAHOO.widget.CalendarNavigator, E = D.CLASSES, B = A;
        B[B.length] = '<div class="' + E.MONTH + '">';
        this.renderMonth(B);
        B[B.length] = "</div>";
        B[B.length] = '<div class="' + E.YEAR + '">';
        this.renderYear(B);
        B[B.length] = "</div>";
        B[B.length] = '<div class="' + E.BUTTONS + '">';
        this.renderButtons(B);
        B[B.length] = "</div>";
        B[B.length] = '<div class="' + E.ERROR + '" id="' + this.id + D.ERROR_SUFFIX + '"></div>';
        return B;
    },
    renderMonth: function (D) {
        var G = YAHOO.widget.CalendarNavigator, H = G.CLASSES;
        var I = this.id + G.MONTH_SUFFIX, F = this.__getCfg("monthFormat"),
            A = this.cal.cfg.getProperty((F == YAHOO.widget.Calendar.SHORT) ? "MONTHS_SHORT" : "MONTHS_LONG"), E = D;
        if (A && A.length > 0) {
            E[E.length] = '<label for="' + I + '">';
            E[E.length] = this.__getCfg("month", true);
            E[E.length] = "</label>";
            E[E.length] = '<select name="' + I + '" id="' + I + '" class="' + H.MONTH_CTRL + '">';
            for (var B = 0; B < A.length; B++) {
                E[E.length] = '<option value="' + B + '">';
                E[E.length] = A[B];
                E[E.length] = "</option>";
            }
            E[E.length] = "</select>";
        }
        return E;
    },
    renderYear: function (B) {
        var E = YAHOO.widget.CalendarNavigator, F = E.CLASSES;
        var G = this.id + E.YEAR_SUFFIX, A = E.YR_MAX_DIGITS, D = B;
        D[D.length] = '<label for="' + G + '">';
        D[D.length] = this.__getCfg("year", true);
        D[D.length] = "</label>";
        D[D.length] = '<input type="text" name="' + G + '" id="' + G + '" class="' + F.YEAR_CTRL + '" maxlength="' + A + '"/>';
        return D;
    },
    renderButtons: function (A) {
        var D = YAHOO.widget.CalendarNavigator.CLASSES;
        var B = A;
        B[B.length] = '<span class="' + D.BUTTON + " " + D.DEFAULT + '">';
        B[B.length] = '<button type="button" id="' + this.id + "_submit" + '">';
        B[B.length] = this.__getCfg("submit", true);
        B[B.length] = "</button>";
        B[B.length] = "</span>";
        B[B.length] = '<span class="' + D.BUTTON + '">';
        B[B.length] = '<button type="button" id="' + this.id + "_cancel" + '">';
        B[B.length] = this.__getCfg("cancel", true);
        B[B.length] = "</button>";
        B[B.length] = "</span>";
        return B;
    },
    applyListeners: function () {
        var B = YAHOO.util.Event;

        function A() {
            if (this.validate()) {
                this.setYear(this._getYearFromUI());
            }
        }

        function C() {
            this.setMonth(this._getMonthFromUI());
        }

        B.on(this.submitEl, "click", this.submit, this, true);
        B.on(this.cancelEl, "click", this.cancel, this, true);
        B.on(this.yearEl, "blur", A, this, true);
        B.on(this.monthEl, "change", C, this, true);
        if (this.__isIEQuirks) {
            YAHOO.util.Event.on(this.cal.oDomContainer, "resize", this._syncMask, this, true);
        }
        this.applyKeyListeners();
    },
    purgeListeners: function () {
        var A = YAHOO.util.Event;
        A.removeListener(this.submitEl, "click", this.submit);
        A.removeListener(this.cancelEl, "click", this.cancel);
        A.removeListener(this.yearEl, "blur");
        A.removeListener(this.monthEl, "change");
        if (this.__isIEQuirks) {
            A.removeListener(this.cal.oDomContainer, "resize", this._syncMask);
        }
        this.purgeKeyListeners();
    },
    applyKeyListeners: function () {
        var D = YAHOO.util.Event, A = YAHOO.env.ua;
        var C = (A.ie || A.webkit) ? "keydown" : "keypress";
        var B = (A.ie || A.opera || A.webkit) ? "keydown" : "keypress";
        D.on(this.yearEl, "keypress", this._handleEnterKey, this, true);
        D.on(this.yearEl, C, this._handleDirectionKeys, this, true);
        D.on(this.lastCtrl, B, this._handleTabKey, this, true);
        D.on(this.firstCtrl, B, this._handleShiftTabKey, this, true);
    },
    purgeKeyListeners: function () {
        var D = YAHOO.util.Event, A = YAHOO.env.ua;
        var C = (A.ie || A.webkit) ? "keydown" : "keypress";
        var B = (A.ie || A.opera || A.webkit) ? "keydown" : "keypress";
        D.removeListener(this.yearEl, "keypress", this._handleEnterKey);
        D.removeListener(this.yearEl, C, this._handleDirectionKeys);
        D.removeListener(this.lastCtrl, B, this._handleTabKey);
        D.removeListener(this.firstCtrl, B, this._handleShiftTabKey);
    },
    submit: function () {
        if (this.validate()) {
            this.hide();
            this.setMonth(this._getMonthFromUI());
            this.setYear(this._getYearFromUI());
            var B = this.cal;
            var A = YAHOO.widget.CalendarNavigator.UPDATE_DELAY;
            if (A > 0) {
                var C = this;
                window.setTimeout(function () {
                    C._update(B);
                }, A);
            } else {
                this._update(B);
            }
        }
    },
    _update: function (A) {
        A.setYear(this.getYear());
        A.setMonth(this.getMonth());
        A.render();
    },
    cancel: function () {
        this.hide();
    },
    validate: function () {
        if (this._getYearFromUI() !== null) {
            this.clearErrors();
            return true;
        } else {
            this.setYearError();
            this.setError(this.__getCfg("invalidYear", true));
            return false;
        }
    },
    setError: function (A) {
        if (this.errorEl) {
            this.errorEl.innerHTML = A;
            this._show(this.errorEl, true);
        }
    },
    clearError: function () {
        if (this.errorEl) {
            this.errorEl.innerHTML = "";
            this._show(this.errorEl, false);
        }
    },
    setYearError: function () {
        YAHOO.util.Dom.addClass(this.yearEl, YAHOO.widget.CalendarNavigator.CLASSES.INVALID);
    },
    clearYearError: function () {
        YAHOO.util.Dom.removeClass(this.yearEl, YAHOO.widget.CalendarNavigator.CLASSES.INVALID);
    },
    clearErrors: function () {
        this.clearError();
        this.clearYearError();
    },
    setInitialFocus: function () {
        var A = this.submitEl, C = this.__getCfg("initialFocus");
        if (C && C.toLowerCase) {
            C = C.toLowerCase();
            if (C == "year") {
                A = this.yearEl;
                try {
                    this.yearEl.select();
                } catch (B) {
                }
            } else {
                if (C == "month") {
                    A = this.monthEl;
                }
            }
        }
        if (A && YAHOO.lang.isFunction(A.focus)) {
            try {
                A.focus();
            } catch (D) {
            }
        }
    },
    erase: function () {
        if (this.__rendered) {
            this.purgeListeners();
            this.yearEl = null;
            this.monthEl = null;
            this.errorEl = null;
            this.submitEl = null;
            this.cancelEl = null;
            this.firstCtrl = null;
            this.lastCtrl = null;
            if (this.navEl) {
                this.navEl.innerHTML = "";
            }
            var B = this.navEl.parentNode;
            if (B) {
                B.removeChild(this.navEl);
            }
            this.navEl = null;
            var A = this.maskEl.parentNode;
            if (A) {
                A.removeChild(this.maskEl);
            }
            this.maskEl = null;
            this.__rendered = false;
        }
    },
    destroy: function () {
        this.erase();
        this._doc = null;
        this.cal = null;
        this.id = null;
    },
    _show: function (B, A) {
        if (B) {
            YAHOO.util.Dom.setStyle(B, "display", (A) ? "block" : "none");
        }
    },
    _getMonthFromUI: function () {
        if (this.monthEl) {
            return this.monthEl.selectedIndex;
        } else {
            return 0;
        }
    },
    _getYearFromUI: function () {
        var B = YAHOO.widget.CalendarNavigator;
        var A = null;
        if (this.yearEl) {
            var C = this.yearEl.value;
            C = C.replace(B.TRIM, "$1");
            if (B.YR_PATTERN.test(C)) {
                A = parseInt(C, 10);
            }
        }
        return A;
    },
    _updateYearUI: function () {
        if (this.yearEl && this._year !== null) {
            this.yearEl.value = this._year;
        }
    },
    _updateMonthUI: function () {
        if (this.monthEl) {
            this.monthEl.selectedIndex = this._month;
        }
    },
    _setFirstLastElements: function () {
        this.firstCtrl = this.monthEl;
        this.lastCtrl = this.cancelEl;
        if (this.__isMac) {
            if (YAHOO.env.ua.webkit && YAHOO.env.ua.webkit < 420) {
                this.firstCtrl = this.monthEl;
                this.lastCtrl = this.yearEl;
            }
            if (YAHOO.env.ua.gecko) {
                this.firstCtrl = this.yearEl;
                this.lastCtrl = this.yearEl;
            }
        }
    },
    _handleEnterKey: function (B) {
        var A = YAHOO.util.KeyListener.KEY;
        if (YAHOO.util.Event.getCharCode(B) == A.ENTER) {
            YAHOO.util.Event.preventDefault(B);
            this.submit();
        }
    },
    _handleDirectionKeys: function (H) {
        var G = YAHOO.util.Event, A = YAHOO.util.KeyListener.KEY, D = YAHOO.widget.CalendarNavigator;
        var F = (this.yearEl.value) ? parseInt(this.yearEl.value, 10) : null;
        if (isFinite(F)) {
            var B = false;
            switch (G.getCharCode(H)) {
                case A.UP:
                    this.yearEl.value = F + D.YR_MINOR_INC;
                    B = true;
                    break;
                case A.DOWN:
                    this.yearEl.value = Math.max(F - D.YR_MINOR_INC, 0);
                    B = true;
                    break;
                case A.PAGE_UP:
                    this.yearEl.value = F + D.YR_MAJOR_INC;
                    B = true;
                    break;
                case A.PAGE_DOWN:
                    this.yearEl.value = Math.max(F - D.YR_MAJOR_INC, 0);
                    B = true;
                    break;
                default:
                    break;
            }
            if (B) {
                G.preventDefault(H);
                try {
                    this.yearEl.select();
                } catch (C) {
                }
            }
        }
    },
    _handleTabKey: function (D) {
        var C = YAHOO.util.Event, A = YAHOO.util.KeyListener.KEY;
        if (C.getCharCode(D) == A.TAB && !D.shiftKey) {
            try {
                C.preventDefault(D);
                this.firstCtrl.focus();
            } catch (B) {
            }
        }
    },
    _handleShiftTabKey: function (D) {
        var C = YAHOO.util.Event, A = YAHOO.util.KeyListener.KEY;
        if (D.shiftKey && C.getCharCode(D) == A.TAB) {
            try {
                C.preventDefault(D);
                this.lastCtrl.focus();
            } catch (B) {
            }
        }
    },
    __getCfg: function (D, B) {
        var C = YAHOO.widget.CalendarNavigator._DEFAULT_CFG;
        var A = this.cal.cfg.getProperty("navigator");
        if (B) {
            return (A !== true && A.strings && A.strings[D]) ? A.strings[D] : C.strings[D];
        } else {
            return (A !== true && A[D]) ? A[D] : C[D];
        }
    },
    __isMac: (navigator.userAgent.toLowerCase().indexOf("macintosh") != -1)
};
YAHOO.register("calendar", YAHOO.widget.Calendar, {version: "2.7.0", build: "1796"});